var map = {
	"./spei12_10_1950.png": 6936,
	"./spei12_10_1951.png": 19412,
	"./spei12_10_1952.png": 4864,
	"./spei12_10_1953.png": 67428,
	"./spei12_10_1954.png": 29820,
	"./spei12_10_1955.png": 97780,
	"./spei12_10_1956.png": 13324,
	"./spei12_10_1957.png": 6932,
	"./spei12_10_1958.png": 57324,
	"./spei12_10_1959.png": 5244,
	"./spei12_10_1960.png": 94012,
	"./spei12_10_1961.png": 72247,
	"./spei12_10_1962.png": 8520,
	"./spei12_10_1963.png": 22900,
	"./spei12_10_1964.png": 38000,
	"./spei12_10_1965.png": 32608,
	"./spei12_10_1966.png": 32972,
	"./spei12_10_1967.png": 9800,
	"./spei12_10_1968.png": 94471,
	"./spei12_10_1969.png": 80060,
	"./spei12_10_1970.png": 48024,
	"./spei12_10_1971.png": 4440,
	"./spei12_10_1972.png": 56596,
	"./spei12_10_1973.png": 36448,
	"./spei12_10_1974.png": 51396,
	"./spei12_10_1975.png": 67580,
	"./spei12_10_1976.png": 24380,
	"./spei12_10_1977.png": 73356,
	"./spei12_10_1978.png": 43132,
	"./spei12_10_1979.png": 65308,
	"./spei12_10_1980.png": 25808,
	"./spei12_10_1981.png": 48348,
	"./spei12_10_1982.png": 97412,
	"./spei12_10_1983.png": 80135,
	"./spei12_10_1984.png": 90280,
	"./spei12_10_1985.png": 49252,
	"./spei12_10_1986.png": 48500,
	"./spei12_10_1987.png": 70392,
	"./spei12_10_1988.png": 4696,
	"./spei12_10_1989.png": 26308,
	"./spei12_10_1990.png": 43768,
	"./spei12_10_1991.png": 42992,
	"./spei12_10_1992.png": 13236,
	"./spei12_10_1993.png": 92500,
	"./spei12_10_1994.png": 61600,
	"./spei12_10_1995.png": 34223,
	"./spei12_10_1996.png": 99112,
	"./spei12_10_1997.png": 75756,
	"./spei12_10_1998.png": 50556,
	"./spei12_10_1999.png": 26760,
	"./spei12_10_2000.png": 19813,
	"./spei12_10_2001.png": 70064,
	"./spei12_10_2002.png": 29980,
	"./spei12_10_2003.png": 18368,
	"./spei12_10_2004.png": 92324,
	"./spei12_10_2005.png": 77912,
	"./spei12_10_2006.png": 21012,
	"./spei12_10_2007.png": 51840,
	"./spei12_10_2008.png": 74076,
	"./spei12_10_2009.png": 19656,
	"./spei12_10_2010.png": 9191,
	"./spei12_10_2011.png": 72520,
	"./spei12_10_2012.png": 68964,
	"./spei12_10_2013.png": 61328,
	"./spei12_10_2014.png": 23476,
	"./spei12_10_2015.png": 7776,
	"./spei12_10_2016.png": 50732,
	"./spei12_10_2017.png": 4976,
	"./spei12_10_2018.png": 4000,
	"./spei12_10_2019.png": 63916,
	"./spei12_10_2020.png": 87020,
	"./spei12_10_2021.png": 32068,
	"./spei12_10_2022.png": 18104,
	"./spei12_10_2023.png": 70260,
	"./spei12_11_1950.png": 18616,
	"./spei12_11_1951.png": 18688,
	"./spei12_11_1952.png": 24320,
	"./spei12_11_1953.png": 31464,
	"./spei12_11_1954.png": 72220,
	"./spei12_11_1955.png": 41624,
	"./spei12_11_1956.png": 83111,
	"./spei12_11_1957.png": 7472,
	"./spei12_11_1958.png": 60500,
	"./spei12_11_1959.png": 17608,
	"./spei12_11_1960.png": 88488,
	"./spei12_11_1961.png": 388,
	"./spei12_11_1962.png": 83452,
	"./spei12_11_1963.png": 18071,
	"./spei12_11_1964.png": 14840,
	"./spei12_11_1965.png": 23087,
	"./spei12_11_1966.png": 59940,
	"./spei12_11_1967.png": 14560,
	"./spei12_11_1968.png": 11876,
	"./spei12_11_1969.png": 37988,
	"./spei12_11_1970.png": 432,
	"./spei12_11_1971.png": 50628,
	"./spei12_11_1972.png": 56436,
	"./spei12_11_1973.png": 73636,
	"./spei12_11_1974.png": 68540,
	"./spei12_11_1975.png": 83924,
	"./spei12_11_1976.png": 32428,
	"./spei12_11_1977.png": 2628,
	"./spei12_11_1978.png": 2980,
	"./spei12_11_1979.png": 36151,
	"./spei12_11_1980.png": 11752,
	"./spei12_11_1981.png": 88396,
	"./spei12_11_1982.png": 99845,
	"./spei12_11_1983.png": 63215,
	"./spei12_11_1984.png": 25876,
	"./spei12_11_1985.png": 5140,
	"./spei12_11_1986.png": 41172,
	"./spei12_11_1987.png": 93948,
	"./spei12_11_1988.png": 80768,
	"./spei12_11_1989.png": 32343,
	"./spei12_11_1990.png": 51000,
	"./spei12_11_1991.png": 29796,
	"./spei12_11_1992.png": 43996,
	"./spei12_11_1993.png": 55776,
	"./spei12_11_1994.png": 31992,
	"./spei12_11_1995.png": 64527,
	"./spei12_11_1996.png": 51336,
	"./spei12_11_1997.png": 92684,
	"./spei12_11_1998.png": 46108,
	"./spei12_11_1999.png": 62096,
	"./spei12_11_2000.png": 24304,
	"./spei12_11_2001.png": 62228,
	"./spei12_11_2002.png": 88192,
	"./spei12_11_2003.png": 64580,
	"./spei12_11_2004.png": 33340,
	"./spei12_11_2005.png": 5916,
	"./spei12_11_2006.png": 96008,
	"./spei12_11_2007.png": 13208,
	"./spei12_11_2008.png": 69208,
	"./spei12_11_2009.png": 42256,
	"./spei12_11_2010.png": 98156,
	"./spei12_11_2011.png": 20332,
	"./spei12_11_2012.png": 80132,
	"./spei12_11_2013.png": 40084,
	"./spei12_11_2014.png": 20340,
	"./spei12_11_2015.png": 16676,
	"./spei12_11_2016.png": 16912,
	"./spei12_11_2017.png": 97364,
	"./spei12_11_2018.png": 65448,
	"./spei12_11_2019.png": 44712,
	"./spei12_11_2020.png": 71563,
	"./spei12_11_2021.png": 48860,
	"./spei12_11_2022.png": 13288,
	"./spei12_11_2023.png": 32256,
	"./spei12_12_1950.png": 59232,
	"./spei12_12_1951.png": 15568,
	"./spei12_12_1952.png": 78036,
	"./spei12_12_1953.png": 59572,
	"./spei12_12_1954.png": 34672,
	"./spei12_12_1955.png": 15640,
	"./spei12_12_1956.png": 42984,
	"./spei12_12_1957.png": 8140,
	"./spei12_12_1958.png": 44216,
	"./spei12_12_1959.png": 14320,
	"./spei12_12_1960.png": 78928,
	"./spei12_12_1961.png": 16464,
	"./spei12_12_1962.png": 84704,
	"./spei12_12_1963.png": 47684,
	"./spei12_12_1964.png": 92540,
	"./spei12_12_1965.png": 48756,
	"./spei12_12_1966.png": 41704,
	"./spei12_12_1967.png": 2084,
	"./spei12_12_1968.png": 76164,
	"./spei12_12_1969.png": 62200,
	"./spei12_12_1970.png": 54292,
	"./spei12_12_1971.png": 68768,
	"./spei12_12_1972.png": 28684,
	"./spei12_12_1973.png": 12112,
	"./spei12_12_1974.png": 10280,
	"./spei12_12_1975.png": 4596,
	"./spei12_12_1976.png": 20740,
	"./spei12_12_1977.png": 45168,
	"./spei12_12_1978.png": 77664,
	"./spei12_12_1979.png": 44676,
	"./spei12_12_1980.png": 37792,
	"./spei12_12_1981.png": 7260,
	"./spei12_12_1982.png": 63540,
	"./spei12_12_1983.png": 47708,
	"./spei12_12_1984.png": 12892,
	"./spei12_12_1985.png": 52404,
	"./spei12_12_1986.png": 66820,
	"./spei12_12_1987.png": 22436,
	"./spei12_12_1988.png": 30648,
	"./spei12_12_1989.png": 78444,
	"./spei12_12_1990.png": 70076,
	"./spei12_12_1991.png": 79640,
	"./spei12_12_1992.png": 7928,
	"./spei12_12_1993.png": 28492,
	"./spei12_12_1994.png": 23232,
	"./spei12_12_1995.png": 4836,
	"./spei12_12_1996.png": 72244,
	"./spei12_12_1997.png": 50216,
	"./spei12_12_1998.png": 520,
	"./spei12_12_1999.png": 65052,
	"./spei12_12_2000.png": 89400,
	"./spei12_12_2001.png": 4560,
	"./spei12_12_2002.png": 64476,
	"./spei12_12_2003.png": 10336,
	"./spei12_12_2004.png": 50520,
	"./spei12_12_2005.png": 34789,
	"./spei12_12_2006.png": 24884,
	"./spei12_12_2007.png": 19372,
	"./spei12_12_2008.png": 12124,
	"./spei12_12_2009.png": 88328,
	"./spei12_12_2010.png": 244,
	"./spei12_12_2011.png": 57544,
	"./spei12_12_2012.png": 49540,
	"./spei12_12_2013.png": 99376,
	"./spei12_12_2014.png": 8500,
	"./spei12_12_2015.png": 88352,
	"./spei12_12_2016.png": 31308,
	"./spei12_12_2017.png": 8848,
	"./spei12_12_2018.png": 65344,
	"./spei12_12_2019.png": 25260,
	"./spei12_12_2020.png": 72904,
	"./spei12_12_2021.png": 49036,
	"./spei12_12_2022.png": 81564,
	"./spei12_12_2023.png": 69520,
	"./spei12_1_1950.png": 26832,
	"./spei12_1_1951.png": 22768,
	"./spei12_1_1952.png": 60992,
	"./spei12_1_1953.png": 51388,
	"./spei12_1_1954.png": 59888,
	"./spei12_1_1955.png": 51724,
	"./spei12_1_1956.png": 11336,
	"./spei12_1_1957.png": 2965,
	"./spei12_1_1958.png": 42008,
	"./spei12_1_1959.png": 14648,
	"./spei12_1_1960.png": 91284,
	"./spei12_1_1961.png": 61120,
	"./spei12_1_1962.png": 38352,
	"./spei12_1_1963.png": 97420,
	"./spei12_1_1964.png": 15819,
	"./spei12_1_1965.png": 23260,
	"./spei12_1_1966.png": 43788,
	"./spei12_1_1967.png": 42136,
	"./spei12_1_1968.png": 47536,
	"./spei12_1_1969.png": 83860,
	"./spei12_1_1970.png": 79232,
	"./spei12_1_1971.png": 69704,
	"./spei12_1_1972.png": 27852,
	"./spei12_1_1973.png": 80348,
	"./spei12_1_1974.png": 6032,
	"./spei12_1_1975.png": 88708,
	"./spei12_1_1976.png": 85144,
	"./spei12_1_1977.png": 95935,
	"./spei12_1_1978.png": 72856,
	"./spei12_1_1979.png": 28780,
	"./spei12_1_1980.png": 47008,
	"./spei12_1_1981.png": 86480,
	"./spei12_1_1982.png": 40748,
	"./spei12_1_1983.png": 26012,
	"./spei12_1_1984.png": 86644,
	"./spei12_1_1985.png": 9516,
	"./spei12_1_1986.png": 83604,
	"./spei12_1_1987.png": 41940,
	"./spei12_1_1988.png": 57452,
	"./spei12_1_1989.png": 77944,
	"./spei12_1_1990.png": 17807,
	"./spei12_1_1991.png": 10368,
	"./spei12_1_1992.png": 5392,
	"./spei12_1_1993.png": 52140,
	"./spei12_1_1994.png": 40036,
	"./spei12_1_1995.png": 93865,
	"./spei12_1_1996.png": 46232,
	"./spei12_1_1997.png": 90776,
	"./spei12_1_1998.png": 19164,
	"./spei12_1_1999.png": 29524,
	"./spei12_1_2000.png": 35460,
	"./spei12_1_2001.png": 91640,
	"./spei12_1_2002.png": 8276,
	"./spei12_1_2003.png": 5584,
	"./spei12_1_2004.png": 8388,
	"./spei12_1_2005.png": 4372,
	"./spei12_1_2006.png": 50704,
	"./spei12_1_2007.png": 25360,
	"./spei12_1_2008.png": 73788,
	"./spei12_1_2009.png": 23164,
	"./spei12_1_2010.png": 9320,
	"./spei12_1_2011.png": 7196,
	"./spei12_1_2012.png": 46996,
	"./spei12_1_2013.png": 55244,
	"./spei12_1_2014.png": 17159,
	"./spei12_1_2015.png": 14536,
	"./spei12_1_2016.png": 53668,
	"./spei12_1_2017.png": 15488,
	"./spei12_1_2018.png": 20064,
	"./spei12_1_2019.png": 26876,
	"./spei12_1_2020.png": 54472,
	"./spei12_1_2021.png": 69084,
	"./spei12_1_2022.png": 11316,
	"./spei12_1_2023.png": 30116,
	"./spei12_2_1950.png": 36340,
	"./spei12_2_1951.png": 87000,
	"./spei12_2_1952.png": 43624,
	"./spei12_2_1953.png": 828,
	"./spei12_2_1954.png": 35364,
	"./spei12_2_1955.png": 24300,
	"./spei12_2_1956.png": 87768,
	"./spei12_2_1957.png": 47924,
	"./spei12_2_1958.png": 22172,
	"./spei12_2_1959.png": 12684,
	"./spei12_2_1960.png": 49296,
	"./spei12_2_1961.png": 20868,
	"./spei12_2_1962.png": 34760,
	"./spei12_2_1963.png": 10408,
	"./spei12_2_1964.png": 64240,
	"./spei12_2_1965.png": 65037,
	"./spei12_2_1966.png": 42860,
	"./spei12_2_1967.png": 58420,
	"./spei12_2_1968.png": 26740,
	"./spei12_2_1969.png": 35344,
	"./spei12_2_1970.png": 57912,
	"./spei12_2_1971.png": 36709,
	"./spei12_2_1972.png": 82836,
	"./spei12_2_1973.png": 62688,
	"./spei12_2_1974.png": 61284,
	"./spei12_2_1975.png": 71440,
	"./spei12_2_1976.png": 50620,
	"./spei12_2_1977.png": 99596,
	"./spei12_2_1978.png": 53020,
	"./spei12_2_1979.png": 69008,
	"./spei12_2_1980.png": 69176,
	"./spei12_2_1981.png": 72544,
	"./spei12_2_1982.png": 55784,
	"./spei12_2_1983.png": 25176,
	"./spei12_2_1984.png": 30176,
	"./spei12_2_1985.png": 27980,
	"./spei12_2_1986.png": 47528,
	"./spei12_2_1987.png": 48476,
	"./spei12_2_1988.png": 85612,
	"./spei12_2_1989.png": 1172,
	"./spei12_2_1990.png": 70008,
	"./spei12_2_1991.png": 75420,
	"./spei12_2_1992.png": 744,
	"./spei12_2_1993.png": 80008,
	"./spei12_2_1994.png": 87840,
	"./spei12_2_1995.png": 82844,
	"./spei12_2_1996.png": 9000,
	"./spei12_2_1997.png": 85644,
	"./spei12_2_1998.png": 76796,
	"./spei12_2_1999.png": 75380,
	"./spei12_2_2000.png": 46052,
	"./spei12_2_2001.png": 2492,
	"./spei12_2_2002.png": 39868,
	"./spei12_2_2003.png": 28256,
	"./spei12_2_2004.png": 18564,
	"./spei12_2_2005.png": 4152,
	"./spei12_2_2006.png": 24872,
	"./spei12_2_2007.png": 61728,
	"./spei12_2_2008.png": 83964,
	"./spei12_2_2009.png": 51924,
	"./spei12_2_2010.png": 41460,
	"./spei12_2_2011.png": 21140,
	"./spei12_2_2012.png": 72824,
	"./spei12_2_2013.png": 83700,
	"./spei12_2_2014.png": 27336,
	"./spei12_2_2015.png": 34016,
	"./spei12_2_2016.png": 54592,
	"./spei12_2_2017.png": 14864,
	"./spei12_2_2018.png": 30240,
	"./spei12_2_2019.png": 51424,
	"./spei12_2_2020.png": 90880,
	"./spei12_2_2021.png": 41956,
	"./spei12_2_2022.png": 27992,
	"./spei12_2_2023.png": 74120,
	"./spei12_3_1950.png": 77484,
	"./spei12_3_1951.png": 76300,
	"./spei12_3_1952.png": 6876,
	"./spei12_3_1953.png": 64640,
	"./spei12_3_1954.png": 28916,
	"./spei12_3_1955.png": 492,
	"./spei12_3_1956.png": 90492,
	"./spei12_3_1957.png": 25424,
	"./spei12_3_1958.png": 58028,
	"./spei12_3_1959.png": 53256,
	"./spei12_3_1960.png": 98376,
	"./spei12_3_1961.png": 79260,
	"./spei12_3_1962.png": 13356,
	"./spei12_3_1963.png": 22204,
	"./spei12_3_1964.png": 18700,
	"./spei12_3_1965.png": 49328,
	"./spei12_3_1966.png": 19692,
	"./spei12_3_1967.png": 24448,
	"./spei12_3_1968.png": 45968,
	"./spei12_3_1969.png": 68300,
	"./spei12_3_1970.png": 26672,
	"./spei12_3_1971.png": 53853,
	"./spei12_3_1972.png": 89172,
	"./spei12_3_1973.png": 27184,
	"./spei12_3_1974.png": 72240,
	"./spei12_3_1975.png": 10164,
	"./spei12_3_1976.png": 76936,
	"./spei12_3_1977.png": 6488,
	"./spei12_3_1978.png": 82416,
	"./spei12_3_1979.png": 8992,
	"./spei12_3_1980.png": 94972,
	"./spei12_3_1981.png": 45796,
	"./spei12_3_1982.png": 29352,
	"./spei12_3_1983.png": 76684,
	"./spei12_3_1984.png": 98068,
	"./spei12_3_1985.png": 18895,
	"./spei12_3_1986.png": 93324,
	"./spei12_3_1987.png": 71560,
	"./spei12_3_1988.png": 90656,
	"./spei12_3_1989.png": 80964,
	"./spei12_3_1990.png": 26928,
	"./spei12_3_1991.png": 36820,
	"./spei12_3_1992.png": 86652,
	"./spei12_3_1993.png": 61592,
	"./spei12_3_1994.png": 10720,
	"./spei12_3_1995.png": 48232,
	"./spei12_3_1996.png": 50572,
	"./spei12_3_1997.png": 43920,
	"./spei12_3_1998.png": 75996,
	"./spei12_3_1999.png": 19224,
	"./spei12_3_2000.png": 81432,
	"./spei12_3_2001.png": 40172,
	"./spei12_3_2002.png": 98080,
	"./spei12_3_2003.png": 23604,
	"./spei12_3_2004.png": 10440,
	"./spei12_3_2005.png": 12780,
	"./spei12_3_2006.png": 22248,
	"./spei12_3_2007.png": 89136,
	"./spei12_3_2008.png": 47935,
	"./spei12_3_2009.png": 16212,
	"./spei12_3_2010.png": 53368,
	"./spei12_3_2011.png": 33672,
	"./spei12_3_2012.png": 90020,
	"./spei12_3_2013.png": 62156,
	"./spei12_3_2014.png": 61332,
	"./spei12_3_2015.png": 20752,
	"./spei12_3_2016.png": 43152,
	"./spei12_3_2017.png": 36248,
	"./spei12_3_2018.png": 59744,
	"./spei12_3_2019.png": 3228,
	"./spei12_3_2020.png": 23348,
	"./spei12_3_2021.png": 10184,
	"./spei12_3_2022.png": 61908,
	"./spei12_3_2023.png": 50868,
	"./spei12_4_1950.png": 26440,
	"./spei12_4_1951.png": 63176,
	"./spei12_4_1952.png": 45144,
	"./spei12_4_1953.png": 83708,
	"./spei12_4_1954.png": 54100,
	"./spei12_4_1955.png": 42400,
	"./spei12_4_1956.png": 2316,
	"./spei12_4_1957.png": 58896,
	"./spei12_4_1958.png": 44596,
	"./spei12_4_1959.png": 87552,
	"./spei12_4_1960.png": 22908,
	"./spei12_4_1961.png": 73104,
	"./spei12_4_1962.png": 32896,
	"./spei12_4_1963.png": 23204,
	"./spei12_4_1964.png": 89436,
	"./spei12_4_1965.png": 65640,
	"./spei12_4_1966.png": 43604,
	"./spei12_4_1967.png": 59748,
	"./spei12_4_1968.png": 27831,
	"./spei12_4_1969.png": 12100,
	"./spei12_4_1970.png": 47496,
	"./spei12_4_1971.png": 36044,
	"./spei12_4_1972.png": 8620,
	"./spei12_4_1973.png": 69808,
	"./spei12_4_1974.png": 77556,
	"./spei12_4_1975.png": 92884,
	"./spei12_4_1976.png": 4056,
	"./spei12_4_1977.png": 83292,
	"./spei12_4_1978.png": 10188,
	"./spei12_4_1979.png": 80408,
	"./spei12_4_1980.png": 30087,
	"./spei12_4_1981.png": 17652,
	"./spei12_4_1982.png": 89228,
	"./spei12_4_1983.png": 40232,
	"./spei12_4_1984.png": 14160,
	"./spei12_4_1985.png": 75476,
	"./spei12_4_1986.png": 99132,
	"./spei12_4_1987.png": 54648,
	"./spei12_4_1988.png": 5252,
	"./spei12_4_1989.png": 62240,
	"./spei12_4_1990.png": 26716,
	"./spei12_4_1991.png": 39224,
	"./spei12_4_1992.png": 31476,
	"./spei12_4_1993.png": 8428,
	"./spei12_4_1994.png": 52192,
	"./spei12_4_1995.png": 88119,
	"./spei12_4_1996.png": 94676,
	"./spei12_4_1997.png": 86952,
	"./spei12_4_1998.png": 31388,
	"./spei12_4_1999.png": 66320,
	"./spei12_4_2000.png": 53751,
	"./spei12_4_2001.png": 59164,
	"./spei12_4_2002.png": 26100,
	"./spei12_4_2003.png": 1280,
	"./spei12_4_2004.png": 75236,
	"./spei12_4_2005.png": 34679,
	"./spei12_4_2006.png": 29380,
	"./spei12_4_2007.png": 37484,
	"./spei12_4_2008.png": 38608,
	"./spei12_4_2009.png": 59624,
	"./spei12_4_2010.png": 1108,
	"./spei12_4_2011.png": 37844,
	"./spei12_4_2012.png": 34804,
	"./spei12_4_2013.png": 35996,
	"./spei12_4_2014.png": 360,
	"./spei12_4_2015.png": 94688,
	"./spei12_4_2016.png": 70071,
	"./spei12_4_2017.png": 11184,
	"./spei12_4_2018.png": 19264,
	"./spei12_4_2019.png": 91840,
	"./spei12_4_2020.png": 75196,
	"./spei12_4_2021.png": 47772,
	"./spei12_4_2022.png": 47484,
	"./spei12_4_2023.png": 53112,
	"./spei12_5_1950.png": 17032,
	"./spei12_5_1951.png": 48588,
	"./spei12_5_1952.png": 69232,
	"./spei12_5_1953.png": 90360,
	"./spei12_5_1954.png": 9067,
	"./spei12_5_1955.png": 87324,
	"./spei12_5_1956.png": 68100,
	"./spei12_5_1957.png": 12644,
	"./spei12_5_1958.png": 64624,
	"./spei12_5_1959.png": 45364,
	"./spei12_5_1960.png": 61428,
	"./spei12_5_1961.png": 6388,
	"./spei12_5_1962.png": 74136,
	"./spei12_5_1963.png": 13728,
	"./spei12_5_1964.png": 30376,
	"./spei12_5_1965.png": 71196,
	"./spei12_5_1966.png": 23788,
	"./spei12_5_1967.png": 31072,
	"./spei12_5_1968.png": 1740,
	"./spei12_5_1969.png": 7796,
	"./spei12_5_1970.png": 92120,
	"./spei12_5_1971.png": 88449,
	"./spei12_5_1972.png": 13820,
	"./spei12_5_1973.png": 84388,
	"./spei12_5_1974.png": 28664,
	"./spei12_5_1975.png": 72740,
	"./spei12_5_1976.png": 26632,
	"./spei12_5_1977.png": 25724,
	"./spei12_5_1978.png": 20816,
	"./spei12_5_1979.png": 15012,
	"./spei12_5_1980.png": 84508,
	"./spei12_5_1981.png": 60608,
	"./spei12_5_1982.png": 76572,
	"./spei12_5_1983.png": 13260,
	"./spei12_5_1984.png": 85412,
	"./spei12_5_1985.png": 1908,
	"./spei12_5_1986.png": 82008,
	"./spei12_5_1987.png": 80356,
	"./spei12_5_1988.png": 62468,
	"./spei12_5_1989.png": 83348,
	"./spei12_5_1990.png": 98108,
	"./spei12_5_1991.png": 67564,
	"./spei12_5_1992.png": 27176,
	"./spei12_5_1993.png": 18804,
	"./spei12_5_1994.png": 42672,
	"./spei12_5_1995.png": 60988,
	"./spei12_5_1996.png": 47212,
	"./spei12_5_1997.png": 50876,
	"./spei12_5_1998.png": 3448,
	"./spei12_5_1999.png": 81164,
	"./spei12_5_2000.png": 95468,
	"./spei12_5_2001.png": 31604,
	"./spei12_5_2002.png": 90092,
	"./spei12_5_2003.png": 75936,
	"./spei12_5_2004.png": 12412,
	"./spei12_5_2005.png": 1544,
	"./spei12_5_2006.png": 17888,
	"./spei12_5_2007.png": 14936,
	"./spei12_5_2008.png": 9292,
	"./spei12_5_2009.png": 37808,
	"./spei12_5_2010.png": 73972,
	"./spei12_5_2011.png": 57256,
	"./spei12_5_2012.png": 62472,
	"./spei12_5_2013.png": 97940,
	"./spei12_5_2014.png": 68988,
	"./spei12_5_2015.png": 20276,
	"./spei12_5_2016.png": 59812,
	"./spei12_5_2017.png": 71704,
	"./spei12_5_2018.png": 24204,
	"./spei12_5_2019.png": 2592,
	"./spei12_5_2020.png": 76192,
	"./spei12_5_2021.png": 44120,
	"./spei12_5_2022.png": 21340,
	"./spei12_5_2023.png": 95188,
	"./spei12_6_1950.png": 10480,
	"./spei12_6_1951.png": 20372,
	"./spei12_6_1952.png": 24200,
	"./spei12_6_1953.png": 51172,
	"./spei12_6_1954.png": 94272,
	"./spei12_6_1955.png": 31784,
	"./spei12_6_1956.png": 67156,
	"./spei12_6_1957.png": 49852,
	"./spei12_6_1958.png": 81928,
	"./spei12_6_1959.png": 8804,
	"./spei12_6_1960.png": 7308,
	"./spei12_6_1961.png": 71604,
	"./spei12_6_1962.png": 74848,
	"./spei12_6_1963.png": 6980,
	"./spei12_6_1964.png": 63992,
	"./spei12_6_1965.png": 96460,
	"./spei12_6_1966.png": 80880,
	"./spei12_6_1967.png": 60408,
	"./spei12_6_1968.png": 99512,
	"./spei12_6_1969.png": 72268,
	"./spei12_6_1970.png": 78900,
	"./spei12_6_1971.png": 63844,
	"./spei12_6_1972.png": 68528,
	"./spei12_6_1973.png": 15828,
	"./spei12_6_1974.png": 4128,
	"./spei12_6_1975.png": 42080,
	"./spei12_6_1976.png": 84772,
	"./spei12_6_1977.png": 88168,
	"./spei12_6_1978.png": 47284,
	"./spei12_6_1979.png": 27136,
	"./spei12_6_1980.png": 69348,
	"./spei12_6_1981.png": 56440,
	"./spei12_6_1982.png": 51140,
	"./spei12_6_1983.png": 8800,
	"./spei12_6_1984.png": 7396,
	"./spei12_6_1985.png": 592,
	"./spei12_6_1986.png": 70152,
	"./spei12_6_1987.png": 76748,
	"./spei12_6_1988.png": 41628,
	"./spei12_6_1989.png": 98428,
	"./spei12_6_1990.png": 64061,
	"./spei12_6_1991.png": 852,
	"./spei12_6_1992.png": 17760,
	"./spei12_6_1993.png": 21740,
	"./spei12_6_1994.png": 22364,
	"./spei12_6_1995.png": 15972,
	"./spei12_6_1996.png": 98932,
	"./spei12_6_1997.png": 39428,
	"./spei12_6_1998.png": 72600,
	"./spei12_6_1999.png": 78012,
	"./spei12_6_2000.png": 76512,
	"./spei12_6_2001.png": 37684,
	"./spei12_6_2002.png": 65892,
	"./spei12_6_2003.png": 32288,
	"./spei12_6_2004.png": 95900,
	"./spei12_6_2005.png": 73596,
	"./spei12_6_2006.png": 24520,
	"./spei12_6_2007.png": 26860,
	"./spei12_6_2008.png": 4724,
	"./spei12_6_2009.png": 23516,
	"./spei12_6_2010.png": 45067,
	"./spei12_6_2011.png": 69716,
	"./spei12_6_2012.png": 41292,
	"./spei12_6_2013.png": 92012,
	"./spei12_6_2014.png": 23412,
	"./spei12_6_2015.png": 35248,
	"./spei12_6_2016.png": 11837,
	"./spei12_6_2017.png": 72708,
	"./spei12_6_2018.png": 44204,
	"./spei12_6_2019.png": 95344,
	"./spei12_6_2020.png": 88756,
	"./spei12_6_2021.png": 68436,
	"./spei12_6_2022.png": 97140,
	"./spei12_6_2023.png": 10268,
	"./spei12_7_1950.png": 25668,
	"./spei12_7_1951.png": 65108,
	"./spei12_7_1952.png": 11540,
	"./spei12_7_1953.png": 8917,
	"./spei12_7_1954.png": 18996,
	"./spei12_7_1955.png": 27244,
	"./spei12_7_1956.png": 3284,
	"./spei12_7_1957.png": 94372,
	"./spei12_7_1958.png": 32784,
	"./spei12_7_1959.png": 58692,
	"./spei12_7_1960.png": 46536,
	"./spei12_7_1961.png": 93832,
	"./spei12_7_1962.png": 80900,
	"./spei12_7_1963.png": 32860,
	"./spei12_7_1964.png": 87892,
	"./spei12_7_1965.png": 4064,
	"./spei12_7_1966.png": 24784,
	"./spei12_7_1967.png": 45788,
	"./spei12_7_1968.png": 49360,
	"./spei12_7_1969.png": 22703,
	"./spei12_7_1970.png": 18424,
	"./spei12_7_1971.png": 26624,
	"./spei12_7_1972.png": 15384,
	"./spei12_7_1973.png": 78052,
	"./spei12_7_1974.png": 65660,
	"./spei12_7_1975.png": 84684,
	"./spei12_7_1976.png": 39312,
	"./spei12_7_1977.png": 68004,
	"./spei12_7_1978.png": 98432,
	"./spei12_7_1979.png": 34164,
	"./spei12_7_1980.png": 42356,
	"./spei12_7_1981.png": 59348,
	"./spei12_7_1982.png": 12936,
	"./spei12_7_1983.png": 86164,
	"./spei12_7_1984.png": 5652,
	"./spei12_7_1985.png": 32944,
	"./spei12_7_1986.png": 57080,
	"./spei12_7_1987.png": 59216,
	"./spei12_7_1988.png": 81939,
	"./spei12_7_1989.png": 47332,
	"./spei12_7_1990.png": 21272,
	"./spei12_7_1991.png": 17396,
	"./spei12_7_1992.png": 75468,
	"./spei12_7_1993.png": 55284,
	"./spei12_7_1994.png": 75824,
	"./spei12_7_1995.png": 3272,
	"./spei12_7_1996.png": 20032,
	"./spei12_7_1997.png": 70692,
	"./spei12_7_1998.png": 32020,
	"./spei12_7_1999.png": 87536,
	"./spei12_7_2000.png": 4464,
	"./spei12_7_2001.png": 92155,
	"./spei12_7_2002.png": 52652,
	"./spei12_7_2003.png": 34264,
	"./spei12_7_2004.png": 56876,
	"./spei12_7_2005.png": 27636,
	"./spei12_7_2006.png": 15328,
	"./spei12_7_2007.png": 37344,
	"./spei12_7_2008.png": 1349,
	"./spei12_7_2009.png": 64719,
	"./spei12_7_2010.png": 85564,
	"./spei12_7_2011.png": 31836,
	"./spei12_7_2012.png": 93988,
	"./spei12_7_2013.png": 71868,
	"./spei12_7_2014.png": 73512,
	"./spei12_7_2015.png": 39260,
	"./spei12_7_2016.png": 26424,
	"./spei12_7_2017.png": 91820,
	"./spei12_7_2018.png": 8920,
	"./spei12_7_2019.png": 22884,
	"./spei12_7_2020.png": 19696,
	"./spei12_7_2021.png": 13664,
	"./spei12_7_2022.png": 49052,
	"./spei12_7_2023.png": 89388,
	"./spei12_8_1950.png": 87540,
	"./spei12_8_1951.png": 32900,
	"./spei12_8_1952.png": 57192,
	"./spei12_8_1953.png": 68112,
	"./spei12_8_1954.png": 57520,
	"./spei12_8_1955.png": 56656,
	"./spei12_8_1956.png": 29936,
	"./spei12_8_1957.png": 16828,
	"./spei12_8_1958.png": 18924,
	"./spei12_8_1959.png": 94044,
	"./spei12_8_1960.png": 51768,
	"./spei12_8_1961.png": 55796,
	"./spei12_8_1962.png": 54168,
	"./spei12_8_1963.png": 87340,
	"./spei12_8_1964.png": 87264,
	"./spei12_8_1965.png": 12640,
	"./spei12_8_1966.png": 17876,
	"./spei12_8_1967.png": 88556,
	"./spei12_8_1968.png": 66460,
	"./spei12_8_1969.png": 37056,
	"./spei12_8_1970.png": 10576,
	"./spei12_8_1971.png": 1328,
	"./spei12_8_1972.png": 20700,
	"./spei12_8_1973.png": 87404,
	"./spei12_8_1974.png": 77536,
	"./spei12_8_1975.png": 64708,
	"./spei12_8_1976.png": 50421,
	"./spei12_8_1977.png": 48368,
	"./spei12_8_1978.png": 12916,
	"./spei12_8_1979.png": 98596,
	"./spei12_8_1980.png": 63408,
	"./spei12_8_1981.png": 98340,
	"./spei12_8_1982.png": 21372,
	"./spei12_8_1983.png": 83728,
	"./spei12_8_1984.png": 85636,
	"./spei12_8_1985.png": 57212,
	"./spei12_8_1986.png": 91832,
	"./spei12_8_1987.png": 77696,
	"./spei12_8_1988.png": 93476,
	"./spei12_8_1989.png": 93207,
	"./spei12_8_1990.png": 32244,
	"./spei12_8_1991.png": 37996,
	"./spei12_8_1992.png": 66396,
	"./spei12_8_1993.png": 58480,
	"./spei12_8_1994.png": 92608,
	"./spei12_8_1995.png": 36096,
	"./spei12_8_1996.png": 86348,
	"./spei12_8_1997.png": 25440,
	"./spei12_8_1998.png": 29904,
	"./spei12_8_1999.png": 6612,
	"./spei12_8_2000.png": 32028,
	"./spei12_8_2001.png": 81640,
	"./spei12_8_2002.png": 78400,
	"./spei12_8_2003.png": 57348,
	"./spei12_8_2004.png": 34192,
	"./spei12_8_2005.png": 72144,
	"./spei12_8_2006.png": 37192,
	"./spei12_8_2007.png": 2948,
	"./spei12_8_2008.png": 90040,
	"./spei12_8_2009.png": 81180,
	"./spei12_8_2010.png": 88364,
	"./spei12_8_2011.png": 90560,
	"./spei12_8_2012.png": 56548,
	"./spei12_8_2013.png": 30292,
	"./spei12_8_2014.png": 32928,
	"./spei12_8_2015.png": 83588,
	"./spei12_8_2016.png": 94908,
	"./spei12_8_2017.png": 16168,
	"./spei12_8_2018.png": 87924,
	"./spei12_8_2019.png": 43508,
	"./spei12_8_2020.png": 49864,
	"./spei12_8_2021.png": 71880,
	"./spei12_8_2022.png": 76680,
	"./spei12_8_2023.png": 48212,
	"./spei12_9_1950.png": 54855,
	"./spei12_9_1951.png": 27656,
	"./spei12_9_1952.png": 25580,
	"./spei12_9_1953.png": 64124,
	"./spei12_9_1954.png": 12136,
	"./spei12_9_1955.png": 22816,
	"./spei12_9_1956.png": 98200,
	"./spei12_9_1957.png": 16932,
	"./spei12_9_1958.png": 47392,
	"./spei12_9_1959.png": 90348,
	"./spei12_9_1960.png": 69980,
	"./spei12_9_1961.png": 99384,
	"./spei12_9_1962.png": 67184,
	"./spei12_9_1963.png": 36564,
	"./spei12_9_1964.png": 5588,
	"./spei12_9_1965.png": 49320,
	"./spei12_9_1966.png": 13556,
	"./spei12_9_1967.png": 54312,
	"./spei12_9_1968.png": 96348,
	"./spei12_9_1969.png": 98115,
	"./spei12_9_1970.png": 89604,
	"./spei12_9_1971.png": 17856,
	"./spei12_9_1972.png": 23071,
	"./spei12_9_1973.png": 60340,
	"./spei12_9_1974.png": 21243,
	"./spei12_9_1975.png": 48120,
	"./spei12_9_1976.png": 25500,
	"./spei12_9_1977.png": 71132,
	"./spei12_9_1978.png": 90292,
	"./spei12_9_1979.png": 77128,
	"./spei12_9_1980.png": 22944,
	"./spei12_9_1981.png": 58872,
	"./spei12_9_1982.png": 32556,
	"./spei12_9_1983.png": 9980,
	"./spei12_9_1984.png": 9828,
	"./spei12_9_1985.png": 31940,
	"./spei12_9_1986.png": 37848,
	"./spei12_9_1987.png": 72728,
	"./spei12_9_1988.png": 15256,
	"./spei12_9_1989.png": 51183,
	"./spei12_9_1990.png": 50992,
	"./spei12_9_1991.png": 50832,
	"./spei12_9_1992.png": 65436,
	"./spei12_9_1993.png": 56,
	"./spei12_9_1994.png": 52312,
	"./spei12_9_1995.png": 79656,
	"./spei12_9_1996.png": 48492,
	"./spei12_9_1997.png": 95904,
	"./spei12_9_1998.png": 51332,
	"./spei12_9_1999.png": 29720,
	"./spei12_9_2000.png": 56092,
	"./spei12_9_2001.png": 29892,
	"./spei12_9_2002.png": 34240,
	"./spei12_9_2003.png": 55020,
	"./spei12_9_2004.png": 95352,
	"./spei12_9_2005.png": 45924,
	"./spei12_9_2006.png": 36671,
	"./spei12_9_2007.png": 39432,
	"./spei12_9_2008.png": 77016,
	"./spei12_9_2009.png": 38988,
	"./spei12_9_2010.png": 45660,
	"./spei12_9_2011.png": 55084,
	"./spei12_9_2012.png": 22228,
	"./spei12_9_2013.png": 86504,
	"./spei12_9_2014.png": 87356,
	"./spei12_9_2015.png": 57564,
	"./spei12_9_2016.png": 63020,
	"./spei12_9_2017.png": 71580,
	"./spei12_9_2018.png": 47000,
	"./spei12_9_2019.png": 47948,
	"./spei12_9_2020.png": 98044,
	"./spei12_9_2021.png": 31352,
	"./spei12_9_2022.png": 48016,
	"./spei12_9_2023.png": 75912,
	"./spei3_10_1950.png": 67068,
	"./spei3_10_1951.png": 2580,
	"./spei3_10_1952.png": 42116,
	"./spei3_10_1953.png": 54008,
	"./spei3_10_1954.png": 33896,
	"./spei3_10_1955.png": 39560,
	"./spei3_10_1956.png": 66740,
	"./spei3_10_1957.png": 9864,
	"./spei3_10_1958.png": 81653,
	"./spei3_10_1959.png": 63160,
	"./spei3_10_1960.png": 25412,
	"./spei3_10_1961.png": 80724,
	"./spei3_10_1962.png": 8736,
	"./spei3_10_1963.png": 21908,
	"./spei3_10_1964.png": 79016,
	"./spei3_10_1965.png": 96420,
	"./spei3_10_1966.png": 73556,
	"./spei3_10_1967.png": 91888,
	"./spei3_10_1968.png": 44916,
	"./spei3_10_1969.png": 63292,
	"./spei3_10_1970.png": 78933,
	"./spei3_10_1971.png": 7184,
	"./spei3_10_1972.png": 52093,
	"./spei3_10_1973.png": 24868,
	"./spei3_10_1974.png": 99256,
	"./spei3_10_1975.png": 29884,
	"./spei3_10_1976.png": 44356,
	"./spei3_10_1977.png": 5164,
	"./spei3_10_1978.png": 57560,
	"./spei3_10_1979.png": 35672,
	"./spei3_10_1980.png": 12272,
	"./spei3_10_1981.png": 37888,
	"./spei3_10_1982.png": 80100,
	"./spei3_10_1983.png": 87992,
	"./spei3_10_1984.png": 79784,
	"./spei3_10_1985.png": 68264,
	"./spei3_10_1986.png": 6440,
	"./spei3_10_1987.png": 61224,
	"./spei3_10_1988.png": 44340,
	"./spei3_10_1989.png": 15916,
	"./spei3_10_1990.png": 62044,
	"./spei3_10_1991.png": 55624,
	"./spei3_10_1992.png": 3968,
	"./spei3_10_1993.png": 96708,
	"./spei3_10_1994.png": 49117,
	"./spei3_10_1995.png": 37468,
	"./spei3_10_1996.png": 10089,
	"./spei3_10_1997.png": 15716,
	"./spei3_10_1998.png": 1336,
	"./spei3_10_1999.png": 64220,
	"./spei3_10_2000.png": 71296,
	"./spei3_10_2001.png": 45252,
	"./spei3_10_2002.png": 53220,
	"./spei3_10_2003.png": 73940,
	"./spei3_10_2004.png": 10956,
	"./spei3_10_2005.png": 48332,
	"./spei3_10_2006.png": 53724,
	"./spei3_10_2007.png": 46280,
	"./spei3_10_2008.png": 24244,
	"./spei3_10_2009.png": 8544,
	"./spei3_10_2010.png": 14256,
	"./spei3_10_2011.png": 52624,
	"./spei3_10_2012.png": 90828,
	"./spei3_10_2013.png": 61048,
	"./spei3_10_2014.png": 57904,
	"./spei3_10_2015.png": 68148,
	"./spei3_10_2016.png": 99828,
	"./spei3_10_2017.png": 21892,
	"./spei3_10_2018.png": 41528,
	"./spei3_10_2019.png": 19908,
	"./spei3_10_2020.png": 89340,
	"./spei3_10_2021.png": 10356,
	"./spei3_10_2022.png": 46464,
	"./spei3_10_2023.png": 71040,
	"./spei3_11_1950.png": 32328,
	"./spei3_11_1951.png": 45492,
	"./spei3_11_1952.png": 29552,
	"./spei3_11_1953.png": 78412,
	"./spei3_11_1954.png": 3320,
	"./spei3_11_1955.png": 85844,
	"./spei3_11_1956.png": 26104,
	"./spei3_11_1957.png": 31364,
	"./spei3_11_1958.png": 73056,
	"./spei3_11_1959.png": 22840,
	"./spei3_11_1960.png": 50949,
	"./spei3_11_1961.png": 1288,
	"./spei3_11_1962.png": 52672,
	"./spei3_11_1963.png": 20600,
	"./spei3_11_1964.png": 29072,
	"./spei3_11_1965.png": 44008,
	"./spei3_11_1966.png": 24460,
	"./spei3_11_1967.png": 24096,
	"./spei3_11_1968.png": 62496,
	"./spei3_11_1969.png": 57500,
	"./spei3_11_1970.png": 34000,
	"./spei3_11_1971.png": 34364,
	"./spei3_11_1972.png": 58360,
	"./spei3_11_1973.png": 66176,
	"./spei3_11_1974.png": 66292,
	"./spei3_11_1975.png": 10236,
	"./spei3_11_1976.png": 97240,
	"./spei3_11_1977.png": 45556,
	"./spei3_11_1978.png": 95256,
	"./spei3_11_1979.png": 39256,
	"./spei3_11_1980.png": 45792,
	"./spei3_11_1981.png": 1824,
	"./spei3_11_1982.png": 46380,
	"./spei3_11_1983.png": 67548,
	"./spei3_11_1984.png": 91751,
	"./spei3_11_1985.png": 99752,
	"./spei3_11_1986.png": 85860,
	"./spei3_11_1987.png": 30640,
	"./spei3_11_1988.png": 33100,
	"./spei3_11_1989.png": 91416,
	"./spei3_11_1990.png": 81008,
	"./spei3_11_1991.png": 87212,
	"./spei3_11_1992.png": 81460,
	"./spei3_11_1993.png": 45036,
	"./spei3_11_1994.png": 95908,
	"./spei3_11_1995.png": 94000,
	"./spei3_11_1996.png": 68044,
	"./spei3_11_1997.png": 7696,
	"./spei3_11_1998.png": 86932,
	"./spei3_11_1999.png": 60112,
	"./spei3_11_2000.png": 89500,
	"./spei3_11_2001.png": 26709,
	"./spei3_11_2002.png": 5972,
	"./spei3_11_2003.png": 30828,
	"./spei3_11_2004.png": 47804,
	"./spei3_11_2005.png": 63792,
	"./spei3_11_2006.png": 44524,
	"./spei3_11_2007.png": 3756,
	"./spei3_11_2008.png": 56068,
	"./spei3_11_2009.png": 96848,
	"./spei3_11_2010.png": 33932,
	"./spei3_11_2011.png": 36128,
	"./spei3_11_2012.png": 31132,
	"./spei3_11_2013.png": 87348,
	"./spei3_11_2014.png": 97312,
	"./spei3_11_2015.png": 1304,
	"./spei3_11_2016.png": 31128,
	"./spei3_11_2017.png": 73640,
	"./spei3_11_2018.png": 45396,
	"./spei3_11_2019.png": 60168,
	"./spei3_11_2020.png": 29716,
	"./spei3_11_2021.png": 2140,
	"./spei3_11_2022.png": 66476,
	"./spei3_11_2023.png": 65480,
	"./spei3_12_1950.png": 76184,
	"./spei3_12_1951.png": 87580,
	"./spei3_12_1952.png": 22200,
	"./spei3_12_1953.png": 6528,
	"./spei3_12_1954.png": 13332,
	"./spei3_12_1955.png": 15280,
	"./spei3_12_1956.png": 76752,
	"./spei3_12_1957.png": 27004,
	"./spei3_12_1958.png": 57108,
	"./spei3_12_1959.png": 72887,
	"./spei3_12_1960.png": 2372,
	"./spei3_12_1961.png": 79216,
	"./spei3_12_1962.png": 70740,
	"./spei3_12_1963.png": 84992,
	"./spei3_12_1964.png": 63908,
	"./spei3_12_1965.png": 3416,
	"./spei3_12_1966.png": 82524,
	"./spei3_12_1967.png": 87424,
	"./spei3_12_1968.png": 64399,
	"./spei3_12_1969.png": 49716,
	"./spei3_12_1970.png": 83156,
	"./spei3_12_1971.png": 63008,
	"./spei3_12_1972.png": 66660,
	"./spei3_12_1973.png": 38108,
	"./spei3_12_1974.png": 75317,
	"./spei3_12_1975.png": 54580,
	"./spei3_12_1976.png": 5665,
	"./spei3_12_1977.png": 12764,
	"./spei3_12_1978.png": 53504,
	"./spei3_12_1979.png": 93688,
	"./spei3_12_1980.png": 1000,
	"./spei3_12_1981.png": 34876,
	"./spei3_12_1982.png": 72380,
	"./spei3_12_1983.png": 15516,
	"./spei3_12_1984.png": 42372,
	"./spei3_12_1985.png": 70340,
	"./spei3_12_1986.png": 75372,
	"./spei3_12_1987.png": 96052,
	"./spei3_12_1988.png": 28900,
	"./spei3_12_1989.png": 12997,
	"./spei3_12_1990.png": 76196,
	"./spei3_12_1991.png": 42204,
	"./spei3_12_1992.png": 26596,
	"./spei3_12_1993.png": 73613,
	"./spei3_12_1994.png": 89312,
	"./spei3_12_1995.png": 40776,
	"./spei3_12_1996.png": 76544,
	"./spei3_12_1997.png": 91848,
	"./spei3_12_1998.png": 68508,
	"./spei3_12_1999.png": 35948,
	"./spei3_12_2000.png": 69364,
	"./spei3_12_2001.png": 30268,
	"./spei3_12_2002.png": 57864,
	"./spei3_12_2003.png": 93332,
	"./spei3_12_2004.png": 58192,
	"./spei3_12_2005.png": 15668,
	"./spei3_12_2006.png": 52880,
	"./spei3_12_2007.png": 67096,
	"./spei3_12_2008.png": 95868,
	"./spei3_12_2009.png": 94452,
	"./spei3_12_2010.png": 95264,
	"./spei3_12_2011.png": 50692,
	"./spei3_12_2012.png": 32640,
	"./spei3_12_2013.png": 48796,
	"./spei3_12_2014.png": 99416,
	"./spei3_12_2015.png": 89988,
	"./spei3_12_2016.png": 5368,
	"./spei3_12_2017.png": 17156,
	"./spei3_12_2018.png": 66980,
	"./spei3_12_2019.png": 50352,
	"./spei3_12_2020.png": 45052,
	"./spei3_12_2021.png": 39556,
	"./spei3_12_2022.png": 15696,
	"./spei3_12_2023.png": 69108,
	"./spei3_1_1950.png": 82200,
	"./spei3_1_1951.png": 29221,
	"./spei3_1_1952.png": 67336,
	"./spei3_1_1953.png": 8880,
	"./spei3_1_1954.png": 44152,
	"./spei3_1_1955.png": 21868,
	"./spei3_1_1956.png": 48324,
	"./spei3_1_1957.png": 28764,
	"./spei3_1_1958.png": 67024,
	"./spei3_1_1959.png": 62960,
	"./spei3_1_1960.png": 87728,
	"./spei3_1_1961.png": 24052,
	"./spei3_1_1962.png": 70840,
	"./spei3_1_1963.png": 79500,
	"./spei3_1_1964.png": 84160,
	"./spei3_1_1965.png": 19484,
	"./spei3_1_1966.png": 14156,
	"./spei3_1_1967.png": 27628,
	"./spei3_1_1968.png": 8860,
	"./spei3_1_1969.png": 1312,
	"./spei3_1_1970.png": 36500,
	"./spei3_1_1971.png": 59372,
	"./spei3_1_1972.png": 49812,
	"./spei3_1_1973.png": 21416,
	"./spei3_1_1974.png": 19244,
	"./spei3_1_1975.png": 58300,
	"./spei3_1_1976.png": 74829,
	"./spei3_1_1977.png": 98248,
	"./spei3_1_1978.png": 34160,
	"./spei3_1_1979.png": 83775,
	"./spei3_1_1980.png": 18952,
	"./spei3_1_1981.png": 94740,
	"./spei3_1_1982.png": 53432,
	"./spei3_1_1983.png": 89836,
	"./spei3_1_1984.png": 32052,
	"./spei3_1_1985.png": 23140,
	"./spei3_1_1986.png": 96748,
	"./spei3_1_1987.png": 15424,
	"./spei3_1_1988.png": 58348,
	"./spei3_1_1989.png": 83904,
	"./spei3_1_1990.png": 72344,
	"./spei3_1_1991.png": 32772,
	"./spei3_1_1992.png": 44693,
	"./spei3_1_1993.png": 69404,
	"./spei3_1_1994.png": 87800,
	"./spei3_1_1995.png": 66368,
	"./spei3_1_1996.png": 12324,
	"./spei3_1_1997.png": 50448,
	"./spei3_1_1998.png": 73552,
	"./spei3_1_1999.png": 82588,
	"./spei3_1_2000.png": 52612,
	"./spei3_1_2001.png": 12064,
	"./spei3_1_2002.png": 13020,
	"./spei3_1_2003.png": 95080,
	"./spei3_1_2004.png": 35836,
	"./spei3_1_2005.png": 72352,
	"./spei3_1_2006.png": 54556,
	"./spei3_1_2007.png": 41468,
	"./spei3_1_2008.png": 11372,
	"./spei3_1_2009.png": 11988,
	"./spei3_1_2010.png": 8216,
	"./spei3_1_2011.png": 61968,
	"./spei3_1_2012.png": 24440,
	"./spei3_1_2013.png": 51808,
	"./spei3_1_2014.png": 2428,
	"./spei3_1_2015.png": 21968,
	"./spei3_1_2016.png": 28768,
	"./spei3_1_2017.png": 30104,
	"./spei3_1_2018.png": 6880,
	"./spei3_1_2019.png": 91784,
	"./spei3_1_2020.png": 69864,
	"./spei3_1_2021.png": 55156,
	"./spei3_1_2022.png": 23192,
	"./spei3_1_2023.png": 43964,
	"./spei3_2_1950.png": 8964,
	"./spei3_2_1951.png": 27996,
	"./spei3_2_1952.png": 62916,
	"./spei3_2_1953.png": 63853,
	"./spei3_2_1954.png": 30156,
	"./spei3_2_1955.png": 73544,
	"./spei3_2_1956.png": 79540,
	"./spei3_2_1957.png": 28168,
	"./spei3_2_1958.png": 62280,
	"./spei3_2_1959.png": 26188,
	"./spei3_2_1960.png": 56532,
	"./spei3_2_1961.png": 46056,
	"./spei3_2_1962.png": 44615,
	"./spei3_2_1963.png": 44272,
	"./spei3_2_1964.png": 67324,
	"./spei3_2_1965.png": 49316,
	"./spei3_2_1966.png": 78780,
	"./spei3_2_1967.png": 47384,
	"./spei3_2_1968.png": 6764,
	"./spei3_2_1969.png": 9008,
	"./spei3_2_1970.png": 2272,
	"./spei3_2_1971.png": 35120,
	"./spei3_2_1972.png": 40836,
	"./spei3_2_1973.png": 76792,
	"./spei3_2_1974.png": 17216,
	"./spei3_2_1975.png": 65740,
	"./spei3_2_1976.png": 79197,
	"./spei3_2_1977.png": 72088,
	"./spei3_2_1978.png": 72213,
	"./spei3_2_1979.png": 91151,
	"./spei3_2_1980.png": 81220,
	"./spei3_2_1981.png": 37400,
	"./spei3_2_1982.png": 54036,
	"./spei3_2_1983.png": 28964,
	"./spei3_2_1984.png": 54148,
	"./spei3_2_1985.png": 50132,
	"./spei3_2_1986.png": 82436,
	"./spei3_2_1987.png": 93500,
	"./spei3_2_1988.png": 97584,
	"./spei3_2_1989.png": 68924,
	"./spei3_2_1990.png": 24728,
	"./spei3_2_1991.png": 70120,
	"./spei3_2_1992.png": 53509,
	"./spei3_2_1993.png": 41068,
	"./spei3_2_1994.png": 78380,
	"./spei3_2_1995.png": 7924,
	"./spei3_2_1996.png": 11796,
	"./spei3_2_1997.png": 42612,
	"./spei3_2_1998.png": 17040,
	"./spei3_2_1999.png": 9599,
	"./spei3_2_2000.png": 43820,
	"./spei3_2_2001.png": 72256,
	"./spei3_2_2002.png": 94716,
	"./spei3_2_2003.png": 6284,
	"./spei3_2_2004.png": 98252,
	"./spei3_2_2005.png": 19060,
	"./spei3_2_2006.png": 77772,
	"./spei3_2_2007.png": 49476,
	"./spei3_2_2008.png": 81128,
	"./spei3_2_2009.png": 26088,
	"./spei3_2_2010.png": 62896,
	"./spei3_2_2011.png": 57092,
	"./spei3_2_2012.png": 82268,
	"./spei3_2_2013.png": 96084,
	"./spei3_2_2014.png": 42332,
	"./spei3_2_2015.png": 74800,
	"./spei3_2_2016.png": 79840,
	"./spei3_2_2017.png": 51208,
	"./spei3_2_2018.png": 34416,
	"./spei3_2_2019.png": 30528,
	"./spei3_2_2020.png": 86980,
	"./spei3_2_2021.png": 92468,
	"./spei3_2_2022.png": 9596,
	"./spei3_2_2023.png": 78832,
	"./spei3_3_1950.png": 91448,
	"./spei3_3_1951.png": 54332,
	"./spei3_3_1952.png": 8060,
	"./spei3_3_1953.png": 96448,
	"./spei3_3_1954.png": 26060,
	"./spei3_3_1955.png": 26372,
	"./spei3_3_1956.png": 67445,
	"./spei3_3_1957.png": 51884,
	"./spei3_3_1958.png": 30192,
	"./spei3_3_1959.png": 45736,
	"./spei3_3_1960.png": 7536,
	"./spei3_3_1961.png": 34224,
	"./spei3_3_1962.png": 56256,
	"./spei3_3_1963.png": 26140,
	"./spei3_3_1964.png": 35704,
	"./spei3_3_1965.png": 11836,
	"./spei3_3_1966.png": 84556,
	"./spei3_3_1967.png": 79296,
	"./spei3_3_1968.png": 38519,
	"./spei3_3_1969.png": 29508,
	"./spei3_3_1970.png": 16488,
	"./spei3_3_1971.png": 36063,
	"./spei3_3_1972.png": 48444,
	"./spei3_3_1973.png": 60996,
	"./spei3_3_1974.png": 51788,
	"./spei3_3_1975.png": 50604,
	"./spei3_3_1976.png": 42864,
	"./spei3_3_1977.png": 92972,
	"./spei3_3_1978.png": 54800,
	"./spei3_3_1979.png": 8212,
	"./spei3_3_1980.png": 41572,
	"./spei3_3_1981.png": 65420,
	"./spei3_3_1982.png": 98792,
	"./spei3_3_1983.png": 14968,
	"./spei3_3_1984.png": 31392,
	"./spei3_3_1985.png": 48088,
	"./spei3_3_1986.png": 50196,
	"./spei3_3_1987.png": 68572,
	"./spei3_3_1988.png": 10588,
	"./spei3_3_1989.png": 14896,
	"./spei3_3_1990.png": 13092,
	"./spei3_3_1991.png": 88884,
	"./spei3_3_1992.png": 14424,
	"./spei3_3_1993.png": 58916,
	"./spei3_3_1994.png": 96652,
	"./spei3_3_1995.png": 91880,
	"./spei3_3_1996.png": 34500,
	"./spei3_3_1997.png": 84188,
	"./spei3_3_1998.png": 67540,
	"./spei3_3_1999.png": 39116,
	"./spei3_3_2000.png": 17564,
	"./spei3_3_2001.png": 96560,
	"./spei3_3_2002.png": 46220,
	"./spei3_3_2003.png": 37287,
	"./spei3_3_2004.png": 50032,
	"./spei3_3_2005.png": 30295,
	"./spei3_3_2006.png": 43228,
	"./spei3_3_2007.png": 40692,
	"./spei3_3_2008.png": 57272,
	"./spei3_3_2009.png": 35416,
	"./spei3_3_2010.png": 62016,
	"./spei3_3_2011.png": 9536,
	"./spei3_3_2012.png": 82180,
	"./spei3_3_2013.png": 14116,
	"./spei3_3_2014.png": 63840,
	"./spei3_3_2015.png": 11080,
	"./spei3_3_2016.png": 11000,
	"./spei3_3_2017.png": 73592,
	"./spei3_3_2018.png": 60935,
	"./spei3_3_2019.png": 58312,
	"./spei3_3_2020.png": 45180,
	"./spei3_3_2021.png": 41716,
	"./spei3_3_2022.png": 27844,
	"./spei3_3_2023.png": 40436,
	"./spei3_4_1950.png": 42748,
	"./spei3_4_1951.png": 58708,
	"./spei3_4_1952.png": 25480,
	"./spei3_4_1953.png": 55032,
	"./spei3_4_1954.png": 52200,
	"./spei3_4_1955.png": 95792,
	"./spei3_4_1956.png": 29408,
	"./spei3_4_1957.png": 26040,
	"./spei3_4_1958.png": 82040,
	"./spei3_4_1959.png": 55088,
	"./spei3_4_1960.png": 55552,
	"./spei3_4_1961.png": 7127,
	"./spei3_4_1962.png": 15096,
	"./spei3_4_1963.png": 58196,
	"./spei3_4_1964.png": 89024,
	"./spei3_4_1965.png": 10624,
	"./spei3_4_1966.png": 31951,
	"./spei3_4_1967.png": 52916,
	"./spei3_4_1968.png": 86119,
	"./spei3_4_1969.png": 92800,
	"./spei3_4_1970.png": 98512,
	"./spei3_4_1971.png": 36880,
	"./spei3_4_1972.png": 75084,
	"./spei3_4_1973.png": 45304,
	"./spei3_4_1974.png": 42160,
	"./spei3_4_1975.png": 68756,
	"./spei3_4_1976.png": 9703,
	"./spei3_4_1977.png": 83768,
	"./spei3_4_1978.png": 25784,
	"./spei3_4_1979.png": 4164,
	"./spei3_4_1980.png": 3912,
	"./spei3_4_1981.png": 10732,
	"./spei3_4_1982.png": 26720,
	"./spei3_4_1983.png": 54076,
	"./spei3_4_1984.png": 30280,
	"./spei3_4_1985.png": 86280,
	"./spei3_4_1986.png": 72388,
	"./spei3_4_1987.png": 17168,
	"./spei3_4_1988.png": 97664,
	"./spei3_4_1989.png": 324,
	"./spei3_4_1990.png": 88195,
	"./spei3_4_1991.png": 60904,
	"./spei3_4_1992.png": 80528,
	"./spei3_4_1993.png": 12332,
	"./spei3_4_1994.png": 36980,
	"./spei3_4_1995.png": 97608,
	"./spei3_4_1996.png": 67712,
	"./spei3_4_1997.png": 90568,
	"./spei3_4_1998.png": 14216,
	"./spei3_4_1999.png": 44704,
	"./spei3_4_2000.png": 82532,
	"./spei3_4_2001.png": 59376,
	"./spei3_4_2002.png": 96911,
	"./spei3_4_2003.png": 29504,
	"./spei3_4_2004.png": 22104,
	"./spei3_4_2005.png": 53956,
	"./spei3_4_2006.png": 25672,
	"./spei3_4_2007.png": 89964,
	"./spei3_4_2008.png": 44976,
	"./spei3_4_2009.png": 29876,
	"./spei3_4_2010.png": 33096,
	"./spei3_4_2011.png": 34740,
	"./spei3_4_2012.png": 98328,
	"./spei3_4_2013.png": 70960,
	"./spei3_4_2014.png": 41352,
	"./spei3_4_2015.png": 91168,
	"./spei3_4_2016.png": 15744,
	"./spei3_4_2017.png": 34044,
	"./spei3_4_2018.png": 58476,
	"./spei3_4_2019.png": 58112,
	"./spei3_4_2020.png": 57064,
	"./spei3_4_2021.png": 21596,
	"./spei3_4_2022.png": 55692,
	"./spei3_4_2023.png": 9936,
	"./spei3_5_1950.png": 34933,
	"./spei3_5_1951.png": 89196,
	"./spei3_5_1952.png": 97581,
	"./spei3_5_1953.png": 70044,
	"./spei3_5_1954.png": 4296,
	"./spei3_5_1955.png": 69668,
	"./spei3_5_1956.png": 37492,
	"./spei3_5_1957.png": 20776,
	"./spei3_5_1958.png": 65216,
	"./spei3_5_1959.png": 33560,
	"./spei3_5_1960.png": 68396,
	"./spei3_5_1961.png": 19488,
	"./spei3_5_1962.png": 97788,
	"./spei3_5_1963.png": 38292,
	"./spei3_5_1964.png": 3476,
	"./spei3_5_1965.png": 69024,
	"./spei3_5_1966.png": 12788,
	"./spei3_5_1967.png": 77604,
	"./spei3_5_1968.png": 38920,
	"./spei3_5_1969.png": 49780,
	"./spei3_5_1970.png": 63364,
	"./spei3_5_1971.png": 46920,
	"./spei3_5_1972.png": 43038,
	"./spei3_5_1973.png": 38016,
	"./spei3_5_1974.png": 88636,
	"./spei3_5_1975.png": 23568,
	"./spei3_5_1976.png": 70951,
	"./spei3_5_1977.png": 41252,
	"./spei3_5_1978.png": 21408,
	"./spei3_5_1979.png": 94512,
	"./spei3_5_1980.png": 41972,
	"./spei3_5_1981.png": 82728,
	"./spei3_5_1982.png": 35596,
	"./spei3_5_1983.png": 1032,
	"./spei3_5_1984.png": 59735,
	"./spei3_5_1985.png": 25624,
	"./spei3_5_1986.png": 67304,
	"./spei3_5_1987.png": 80172,
	"./spei3_5_1988.png": 49068,
	"./spei3_5_1989.png": 160,
	"./spei3_5_1990.png": 55988,
	"./spei3_5_1991.png": 6408,
	"./spei3_5_1992.png": 58340,
	"./spei3_5_1993.png": 56144,
	"./spei3_5_1994.png": 76996,
	"./spei3_5_1995.png": 23532,
	"./spei3_5_1996.png": 23168,
	"./spei3_5_1997.png": 24252,
	"./spei3_5_1998.png": 44452,
	"./spei3_5_1999.png": 97972,
	"./spei3_5_2000.png": 3060,
	"./spei3_5_2001.png": 15748,
	"./spei3_5_2002.png": 84984,
	"./spei3_5_2003.png": 44436,
	"./spei3_5_2004.png": 80876,
	"./spei3_5_2005.png": 96864,
	"./spei3_5_2006.png": 24220,
	"./spei3_5_2007.png": 424,
	"./spei3_5_2008.png": 78388,
	"./spei3_5_2009.png": 40307,
	"./spei3_5_2010.png": 12048,
	"./spei3_5_2011.png": 16680,
	"./spei3_5_2012.png": 79591,
	"./spei3_5_2013.png": 92388,
	"./spei3_5_2014.png": 68400,
	"./spei3_5_2015.png": 84387,
	"./spei3_5_2016.png": 44972,
	"./spei3_5_2017.png": 15192,
	"./spei3_5_2018.png": 93016,
	"./spei3_5_2019.png": 31580,
	"./spei3_5_2020.png": 46728,
	"./spei3_5_2021.png": 87484,
	"./spei3_5_2022.png": 24000,
	"./spei3_5_2023.png": 50548,
	"./spei3_6_1950.png": 39328,
	"./spei3_6_1951.png": 13700,
	"./spei3_6_1952.png": 46871,
	"./spei3_6_1953.png": 71592,
	"./spei3_6_1954.png": 72384,
	"./spei3_6_1955.png": 94400,
	"./spei3_6_1956.png": 15728,
	"./spei3_6_1957.png": 84692,
	"./spei3_6_1958.png": 70312,
	"./spei3_6_1959.png": 46956,
	"./spei3_6_1960.png": 27101,
	"./spei3_6_1961.png": 42484,
	"./spei3_6_1962.png": 9256,
	"./spei3_6_1963.png": 90808,
	"./spei3_6_1964.png": 29372,
	"./spei3_6_1965.png": 31568,
	"./spei3_6_1966.png": 35148,
	"./spei3_6_1967.png": 32196,
	"./spei3_6_1968.png": 88196,
	"./spei3_6_1969.png": 38864,
	"./spei3_6_1970.png": 7004,
	"./spei3_6_1971.png": 70720,
	"./spei3_6_1972.png": 43344,
	"./spei3_6_1973.png": 46444,
	"./spei3_6_1974.png": 66644,
	"./spei3_6_1975.png": 23752,
	"./spei3_6_1976.png": 60268,
	"./spei3_6_1977.png": 26120,
	"./spei3_6_1978.png": 78364,
	"./spei3_6_1979.png": 18148,
	"./spei3_6_1980.png": 36967,
	"./spei3_6_1981.png": 31536,
	"./spei3_6_1982.png": 36012,
	"./spei3_6_1983.png": 90256,
	"./spei3_6_1984.png": 63736,
	"./spei3_6_1985.png": 94364,
	"./spei3_6_1986.png": 42348,
	"./spei3_6_1987.png": 33836,
	"./spei3_6_1988.png": 84976,
	"./spei3_6_1989.png": 64504,
	"./spei3_6_1990.png": 16492,
	"./spei3_6_1991.png": 15308,
	"./spei3_6_1992.png": 45884,
	"./spei3_6_1993.png": 3648,
	"./spei3_6_1994.png": 67924,
	"./spei3_6_1995.png": 17120,
	"./spei3_6_1996.png": 90767,
	"./spei3_6_1997.png": 25700,
	"./spei3_6_1998.png": 58720,
	"./spei3_6_1999.png": 97876,
	"./spei3_6_2000.png": 71544,
	"./spei3_6_2001.png": 93619,
	"./spei3_6_2002.png": 88880,
	"./spei3_6_2003.png": 1284,
	"./spei3_6_2004.png": 21196,
	"./spei3_6_2005.png": 66748,
	"./spei3_6_2006.png": 9164,
	"./spei3_6_2007.png": 52552,
	"./spei3_6_2008.png": 50044,
	"./spei3_6_2009.png": 22712,
	"./spei3_6_2010.png": 89744,
	"./spei3_6_2011.png": 47588,
	"./spei3_6_2012.png": 11228,
	"./spei3_6_2013.png": 35404,
	"./spei3_6_2014.png": 49383,
	"./spei3_6_2015.png": 43880,
	"./spei3_6_2016.png": 46420,
	"./spei3_6_2017.png": 87933,
	"./spei3_6_2018.png": 5864,
	"./spei3_6_2019.png": 74524,
	"./spei3_6_2020.png": 81280,
	"./spei3_6_2021.png": 99316,
	"./spei3_6_2022.png": 57036,
	"./spei3_6_2023.png": 77764,
	"./spei3_7_1950.png": 44652,
	"./spei3_7_1951.png": 23644,
	"./spei3_7_1952.png": 89352,
	"./spei3_7_1953.png": 68840,
	"./spei3_7_1954.png": 25348,
	"./spei3_7_1955.png": 81355,
	"./spei3_7_1956.png": 22356,
	"./spei3_7_1957.png": 15237,
	"./spei3_7_1958.png": 26328,
	"./spei3_7_1959.png": 5672,
	"./spei3_7_1960.png": 8788,
	"./spei3_7_1961.png": 52740,
	"./spei3_7_1962.png": 79132,
	"./spei3_7_1963.png": 72944,
	"./spei3_7_1964.png": 81036,
	"./spei3_7_1965.png": 59424,
	"./spei3_7_1966.png": 41028,
	"./spei3_7_1967.png": 23552,
	"./spei3_7_1968.png": 41596,
	"./spei3_7_1969.png": 72660,
	"./spei3_7_1970.png": 13880,
	"./spei3_7_1971.png": 27000,
	"./spei3_7_1972.png": 57628,
	"./spei3_7_1973.png": 99160,
	"./spei3_7_1974.png": 97100,
	"./spei3_7_1975.png": 7684,
	"./spei3_7_1976.png": 86444,
	"./spei3_7_1977.png": 75144,
	"./spei3_7_1978.png": 53928,
	"./spei3_7_1979.png": 63504,
	"./spei3_7_1980.png": 40472,
	"./spei3_7_1981.png": 77596,
	"./spei3_7_1982.png": 99196,
	"./spei3_7_1983.png": 45056,
	"./spei3_7_1984.png": 23972,
	"./spei3_7_1985.png": 63480,
	"./spei3_7_1986.png": 75956,
	"./spei3_7_1987.png": 47904,
	"./spei3_7_1988.png": 46844,
	"./spei3_7_1989.png": 39400,
	"./spei3_7_1990.png": 20840,
	"./spei3_7_1991.png": 45612,
	"./spei3_7_1992.png": 43648,
	"./spei3_7_1993.png": 43568,
	"./spei3_7_1994.png": 34964,
	"./spei3_7_1995.png": 44264,
	"./spei3_7_1996.png": 78232,
	"./spei3_7_1997.png": 72828,
	"./spei3_7_1998.png": 61567,
	"./spei3_7_1999.png": 76132,
	"./spei3_7_2000.png": 20232,
	"./spei3_7_2001.png": 16300,
	"./spei3_7_2002.png": 12820,
	"./spei3_7_2003.png": 82320,
	"./spei3_7_2004.png": 24976,
	"./spei3_7_2005.png": 96056,
	"./spei3_7_2006.png": 50276,
	"./spei3_7_2007.png": 42232,
	"./spei3_7_2008.png": 10060,
	"./spei3_7_2009.png": 84892,
	"./spei3_7_2010.png": 74976,
	"./spei3_7_2011.png": 98804,
	"./spei3_7_2012.png": 48353,
	"./spei3_7_2013.png": 39367,
	"./spei3_7_2014.png": 508,
	"./spei3_7_2015.png": 53672,
	"./spei3_7_2016.png": 83620,
	"./spei3_7_2017.png": 79660,
	"./spei3_7_2018.png": 94968,
	"./spei3_7_2019.png": 83936,
	"./spei3_7_2020.png": 39112,
	"./spei3_7_2021.png": 47228,
	"./spei3_7_2022.png": 84732,
	"./spei3_7_2023.png": 5524,
	"./spei3_8_1950.png": 94412,
	"./spei3_8_1951.png": 61856,
	"./spei3_8_1952.png": 1840,
	"./spei3_8_1953.png": 80660,
	"./spei3_8_1954.png": 75464,
	"./spei3_8_1955.png": 17420,
	"./spei3_8_1956.png": 46044,
	"./spei3_8_1957.png": 19972,
	"./spei3_8_1958.png": 81288,
	"./spei3_8_1959.png": 70184,
	"./spei3_8_1960.png": 96968,
	"./spei3_8_1961.png": 67268,
	"./spei3_8_1962.png": 14652,
	"./spei3_8_1963.png": 65936,
	"./spei3_8_1964.png": 29752,
	"./spei3_8_1965.png": 58004,
	"./spei3_8_1966.png": 67416,
	"./spei3_8_1967.png": 43316,
	"./spei3_8_1968.png": 93172,
	"./spei3_8_1969.png": 10648,
	"./spei3_8_1970.png": 43600,
	"./spei3_8_1971.png": 86556,
	"./spei3_8_1972.png": 3981,
	"./spei3_8_1973.png": 48452,
	"./spei3_8_1974.png": 11132,
	"./spei3_8_1975.png": 79092,
	"./spei3_8_1976.png": 71484,
	"./spei3_8_1977.png": 29444,
	"./spei3_8_1978.png": 7000,
	"./spei3_8_1979.png": 92588,
	"./spei3_8_1980.png": 38152,
	"./spei3_8_1981.png": 44832,
	"./spei3_8_1982.png": 87788,
	"./spei3_8_1983.png": 42032,
	"./spei3_8_1984.png": 68628,
	"./spei3_8_1985.png": 31956,
	"./spei3_8_1986.png": 99992,
	"./spei3_8_1987.png": 20764,
	"./spei3_8_1988.png": 77964,
	"./spei3_8_1989.png": 97892,
	"./spei3_8_1990.png": 196,
	"./spei3_8_1991.png": 56196,
	"./spei3_8_1992.png": 80776,
	"./spei3_8_1993.png": 30592,
	"./spei3_8_1994.png": 45540,
	"./spei3_8_1995.png": 20963,
	"./spei3_8_1996.png": 86300,
	"./spei3_8_1997.png": 97536,
	"./spei3_8_1998.png": 50960,
	"./spei3_8_1999.png": 95101,
	"./spei3_8_2000.png": 8288,
	"./spei3_8_2001.png": 39456,
	"./spei3_8_2002.png": 90511,
	"./spei3_8_2003.png": 33228,
	"./spei3_8_2004.png": 22112,
	"./spei3_8_2005.png": 48572,
	"./spei3_8_2006.png": 89380,
	"./spei3_8_2007.png": 20472,
	"./spei3_8_2008.png": 90856,
	"./spei3_8_2009.png": 99500,
	"./spei3_8_2010.png": 55308,
	"./spei3_8_2011.png": 84000,
	"./spei3_8_2012.png": 16948,
	"./spei3_8_2013.png": 46740,
	"./spei3_8_2014.png": 77031,
	"./spei3_8_2015.png": 15184,
	"./spei3_8_2016.png": 63496,
	"./spei3_8_2017.png": 74272,
	"./spei3_8_2018.png": 17896,
	"./spei3_8_2019.png": 30208,
	"./spei3_8_2020.png": 99052,
	"./spei3_8_2021.png": 99684,
	"./spei3_8_2022.png": 12181,
	"./spei3_8_2023.png": 47696,
	"./spei3_9_1950.png": 99288,
	"./spei3_9_1951.png": 31140,
	"./spei3_9_1952.png": 25841,
	"./spei3_9_1953.png": 83500,
	"./spei3_9_1954.png": 37336,
	"./spei3_9_1955.png": 59100,
	"./spei3_9_1956.png": 22056,
	"./spei3_9_1957.png": 58688,
	"./spei3_9_1958.png": 78172,
	"./spei3_9_1959.png": 96144,
	"./spei3_9_1960.png": 98220,
	"./spei3_9_1961.png": 22868,
	"./spei3_9_1962.png": 57720,
	"./spei3_9_1963.png": 45741,
	"./spei3_9_1964.png": 67296,
	"./spei3_9_1965.png": 10364,
	"./spei3_9_1966.png": 41428,
	"./spei3_9_1967.png": 42212,
	"./spei3_9_1968.png": 13708,
	"./spei3_9_1969.png": 70460,
	"./spei3_9_1970.png": 84551,
	"./spei3_9_1971.png": 93768,
	"./spei3_9_1972.png": 96108,
	"./spei3_9_1973.png": 34452,
	"./spei3_9_1974.png": 72464,
	"./spei3_9_1975.png": 53644,
	"./spei3_9_1976.png": 61808,
	"./spei3_9_1977.png": 58988,
	"./spei3_9_1978.png": 67928,
	"./spei3_9_1979.png": 18144,
	"./spei3_9_1980.png": 49104,
	"./spei3_9_1981.png": 17064,
	"./spei3_9_1982.png": 54988,
	"./spei3_9_1983.png": 54624,
	"./spei3_9_1984.png": 32248,
	"./spei3_9_1985.png": 74344,
	"./spei3_9_1986.png": 36364,
	"./spei3_9_1987.png": 92740,
	"./spei3_9_1988.png": 94840,
	"./spei3_9_1989.png": 67056,
	"./spei3_9_1990.png": 49860,
	"./spei3_9_1991.png": 90640,
	"./spei3_9_1992.png": 69820,
	"./spei3_9_1993.png": 61324,
	"./spei3_9_1994.png": 42936,
	"./spei3_9_1995.png": 78788,
	"./spei3_9_1996.png": 20884,
	"./spei3_9_1997.png": 5184,
	"./spei3_9_1998.png": 28688,
	"./spei3_9_1999.png": 98120,
	"./spei3_9_2000.png": 78264,
	"./spei3_9_2001.png": 32132,
	"./spei3_9_2002.png": 94244,
	"./spei3_9_2003.png": 72632,
	"./spei3_9_2004.png": 64961,
	"./spei3_9_2005.png": 37736,
	"./spei3_9_2006.png": 91584,
	"./spei3_9_2007.png": 70160,
	"./spei3_9_2008.png": 8348,
	"./spei3_9_2009.png": 42967,
	"./spei3_9_2010.png": 73956,
	"./spei3_9_2011.png": 61047,
	"./spei3_9_2012.png": 55748,
	"./spei3_9_2013.png": 13408,
	"./spei3_9_2014.png": 12004,
	"./spei3_9_2015.png": 5200,
	"./spei3_9_2016.png": 96724,
	"./spei3_9_2017.png": 10976,
	"./spei3_9_2018.png": 75856,
	"./spei3_9_2019.png": 48432,
	"./spei3_9_2020.png": 72888,
	"./spei3_9_2021.png": 91924,
	"./spei3_9_2022.png": 25892,
	"./spei3_9_2023.png": 69460,
	"./spei6_10_1950.png": 22328,
	"./spei6_10_1951.png": 62740,
	"./spei6_10_1952.png": 26005,
	"./spei6_10_1953.png": 36080,
	"./spei6_10_1954.png": 11716,
	"./spei6_10_1955.png": 66668,
	"./spei6_10_1956.png": 63088,
	"./spei6_10_1957.png": 38512,
	"./spei6_10_1958.png": 72716,
	"./spei6_10_1959.png": 91984,
	"./spei6_10_1960.png": 31312,
	"./spei6_10_1961.png": 71448,
	"./spei6_10_1962.png": 26284,
	"./spei6_10_1963.png": 25504,
	"./spei6_10_1964.png": 772,
	"./spei6_10_1965.png": 25492,
	"./spei6_10_1966.png": 41228,
	"./spei6_10_1967.png": 459,
	"./spei6_10_1968.png": 68868,
	"./spei6_10_1969.png": 62064,
	"./spei6_10_1970.png": 60636,
	"./spei6_10_1971.png": 22072,
	"./spei6_10_1972.png": 44448,
	"./spei6_10_1973.png": 33212,
	"./spei6_10_1974.png": 97496,
	"./spei6_10_1975.png": 89080,
	"./spei6_10_1976.png": 52044,
	"./spei6_10_1977.png": 27272,
	"./spei6_10_1978.png": 23356,
	"./spei6_10_1979.png": 27836,
	"./spei6_10_1980.png": 92644,
	"./spei6_10_1981.png": 92367,
	"./spei6_10_1982.png": 87468,
	"./spei6_10_1983.png": 43476,
	"./spei6_10_1984.png": 16476,
	"./spei6_10_1985.png": 20784,
	"./spei6_10_1986.png": 81132,
	"./spei6_10_1987.png": 13277,
	"./spei6_10_1988.png": 37280,
	"./spei6_10_1989.png": 53976,
	"./spei6_10_1990.png": 69936,
	"./spei6_10_1991.png": 35004,
	"./spei6_10_1992.png": 61356,
	"./spei6_10_1993.png": 3048,
	"./spei6_10_1994.png": 3123,
	"./spei6_10_1995.png": 67740,
	"./spei6_10_1996.png": 89440,
	"./spei6_10_1997.png": 38348,
	"./spei6_10_1998.png": 42840,
	"./spei6_10_1999.png": 20312,
	"./spei6_10_2000.png": 40404,
	"./spei6_10_2001.png": 22588,
	"./spei6_10_2002.png": 63032,
	"./spei6_10_2003.png": 94616,
	"./spei6_10_2004.png": 19831,
	"./spei6_10_2005.png": 2300,
	"./spei6_10_2006.png": 40068,
	"./spei6_10_2007.png": 66527,
	"./spei6_10_2008.png": 63610,
	"./spei6_10_2009.png": 99048,
	"./spei6_10_2010.png": 85884,
	"./spei6_10_2011.png": 22184,
	"./spei6_10_2012.png": 65460,
	"./spei6_10_2013.png": 1556,
	"./spei6_10_2014.png": 90452,
	"./spei6_10_2015.png": 95816,
	"./spei6_10_2016.png": 45900,
	"./spei6_10_2017.png": 37240,
	"./spei6_10_2018.png": 46204,
	"./spei6_10_2019.png": 45004,
	"./spei6_10_2020.png": 83472,
	"./spei6_10_2021.png": 86116,
	"./spei6_10_2022.png": 60316,
	"./spei6_10_2023.png": 57780,
	"./spei6_11_1950.png": 28612,
	"./spei6_11_1951.png": 52900,
	"./spei6_11_1952.png": 2095,
	"./spei6_11_1953.png": 66572,
	"./spei6_11_1954.png": 22580,
	"./spei6_11_1955.png": 38359,
	"./spei6_11_1956.png": 7756,
	"./spei6_11_1957.png": 2984,
	"./spei6_11_1958.png": 78804,
	"./spei6_11_1959.png": 80751,
	"./spei6_11_1960.png": 67844,
	"./spei6_11_1961.png": 44688,
	"./spei6_11_1962.png": 82224,
	"./spei6_11_1963.png": 73004,
	"./spei6_11_1964.png": 91064,
	"./spei6_11_1965.png": 39268,
	"./spei6_11_1966.png": 10984,
	"./spei6_11_1967.png": 75276,
	"./spei6_11_1968.png": 36476,
	"./spei6_11_1969.png": 15188,
	"./spei6_11_1970.png": 40788,
	"./spei6_11_1971.png": 20052,
	"./spei6_11_1972.png": 87712,
	"./spei6_11_1973.png": 51988,
	"./spei6_11_1974.png": 48628,
	"./spei6_11_1975.png": 28480,
	"./spei6_11_1976.png": 1056,
	"./spei6_11_1977.png": 96976,
	"./spei6_11_1978.png": 76644,
	"./spei6_11_1979.png": 43424,
	"./spei6_11_1980.png": 49616,
	"./spei6_11_1981.png": 34516,
	"./spei6_11_1982.png": 20136,
	"./spei6_11_1983.png": 83864,
	"./spei6_11_1984.png": 12292,
	"./spei6_11_1985.png": 55248,
	"./spei6_11_1986.png": 53356,
	"./spei6_11_1987.png": 51320,
	"./spei6_11_1988.png": 87172,
	"./spei6_11_1989.png": 64016,
	"./spei6_11_1990.png": 63116,
	"./spei6_11_1991.png": 62752,
	"./spei6_11_1992.png": 63260,
	"./spei6_11_1993.png": 31221,
	"./spei6_11_1994.png": 38304,
	"./spei6_11_1995.png": 868,
	"./spei6_11_1996.png": 40376,
	"./spei6_11_1997.png": 82472,
	"./spei6_11_1998.png": 15356,
	"./spei6_11_1999.png": 17000,
	"./spei6_11_2000.png": 61304,
	"./spei6_11_2001.png": 17636,
	"./spei6_11_2002.png": 66040,
	"./spei6_11_2003.png": 60972,
	"./spei6_11_2004.png": 8892,
	"./spei6_11_2005.png": 7596,
	"./spei6_11_2006.png": 29628,
	"./spei6_11_2007.png": 68232,
	"./spei6_11_2008.png": 64652,
	"./spei6_11_2009.png": 60780,
	"./spei6_11_2010.png": 33112,
	"./spei6_11_2011.png": 81636,
	"./spei6_11_2012.png": 28308,
	"./spei6_11_2013.png": 55580,
	"./spei6_11_2014.png": 6040,
	"./spei6_11_2015.png": 2988,
	"./spei6_11_2016.png": 70320,
	"./spei6_11_2017.png": 67932,
	"./spei6_11_2018.png": 87792,
	"./spei6_11_2019.png": 88752,
	"./spei6_11_2020.png": 71816,
	"./spei6_11_2021.png": 56724,
	"./spei6_11_2022.png": 80572,
	"./spei6_11_2023.png": 40216,
	"./spei6_12_1950.png": 58200,
	"./spei6_12_1951.png": 52804,
	"./spei6_12_1952.png": 65301,
	"./spei6_12_1953.png": 6844,
	"./spei6_12_1954.png": 19736,
	"./spei6_12_1955.png": 75072,
	"./spei6_12_1956.png": 23908,
	"./spei6_12_1957.png": 33968,
	"./spei6_12_1958.png": 58960,
	"./spei6_12_1959.png": 90544,
	"./spei6_12_1960.png": 85853,
	"./spei6_12_1961.png": 95220,
	"./spei6_12_1962.png": 46008,
	"./spei6_12_1963.png": 60864,
	"./spei6_12_1964.png": 57280,
	"./spei6_12_1965.png": 84136,
	"./spei6_12_1966.png": 89740,
	"./spei6_12_1967.png": 61327,
	"./spei6_12_1968.png": 84679,
	"./spei6_12_1969.png": 39502,
	"./spei6_12_1970.png": 12084,
	"./spei6_12_1971.png": 33244,
	"./spei6_12_1972.png": 62588,
	"./spei6_12_1973.png": 65588,
	"./spei6_12_1974.png": 88800,
	"./spei6_12_1975.png": 30513,
	"./spei6_12_1976.png": 66188,
	"./spei6_12_1977.png": 15880,
	"./spei6_12_1978.png": 9744,
	"./spei6_12_1979.png": 496,
	"./spei6_12_1980.png": 33269,
	"./spei6_12_1981.png": 48360,
	"./spei6_12_1982.png": 28599,
	"./spei6_12_1983.png": 31184,
	"./spei6_12_1984.png": 85256,
	"./spei6_12_1985.png": 21104,
	"./spei6_12_1986.png": 72332,
	"./spei6_12_1987.png": 91008,
	"./spei6_12_1988.png": 11552,
	"./spei6_12_1989.png": 65677,
	"./spei6_12_1990.png": 64280,
	"./spei6_12_1991.png": 8356,
	"./spei6_12_1992.png": 14248,
	"./spei6_12_1993.png": 44988,
	"./spei6_12_1994.png": 33764,
	"./spei6_12_1995.png": 85332,
	"./spei6_12_1996.png": 49436,
	"./spei6_12_1997.png": 70954,
	"./spei6_12_1998.png": 97136,
	"./spei6_12_1999.png": 51984,
	"./spei6_12_2000.png": 84528,
	"./spei6_12_2001.png": 22141,
	"./spei6_12_2002.png": 98972,
	"./spei6_12_2003.png": 4880,
	"./spei6_12_2004.png": 85848,
	"./spei6_12_2005.png": 96839,
	"./spei6_12_2006.png": 65676,
	"./spei6_12_2007.png": 29440,
	"./spei6_12_2008.png": 85776,
	"./spei6_12_2009.png": 63256,
	"./spei6_12_2010.png": 20508,
	"./spei6_12_2011.png": 67584,
	"./spei6_12_2012.png": 71956,
	"./spei6_12_2013.png": 18407,
	"./spei6_12_2014.png": 71260,
	"./spei6_12_2015.png": 96656,
	"./spei6_12_2016.png": 47232,
	"./spei6_12_2017.png": 73276,
	"./spei6_12_2018.png": 48228,
	"./spei6_12_2019.png": 3564,
	"./spei6_12_2020.png": 61448,
	"./spei6_12_2021.png": 28788,
	"./spei6_12_2022.png": 18916,
	"./spei6_12_2023.png": 58508,
	"./spei6_1_1950.png": 72400,
	"./spei6_1_1951.png": 11060,
	"./spei6_1_1952.png": 30232,
	"./spei6_1_1953.png": 24596,
	"./spei6_1_1954.png": 90036,
	"./spei6_1_1955.png": 64512,
	"./spei6_1_1956.png": 84224,
	"./spei6_1_1957.png": 80492,
	"./spei6_1_1958.png": 75716,
	"./spei6_1_1959.png": 91504,
	"./spei6_1_1960.png": 32088,
	"./spei6_1_1961.png": 5068,
	"./spei6_1_1962.png": 7580,
	"./spei6_1_1963.png": 26456,
	"./spei6_1_1964.png": 79444,
	"./spei6_1_1965.png": 51944,
	"./spei6_1_1966.png": 26176,
	"./spei6_1_1967.png": 69660,
	"./spei6_1_1968.png": 79964,
	"./spei6_1_1969.png": 25060,
	"./spei6_1_1970.png": 66112,
	"./spei6_1_1971.png": 55312,
	"./spei6_1_1972.png": 41836,
	"./spei6_1_1973.png": 98620,
	"./spei6_1_1974.png": 76616,
	"./spei6_1_1975.png": 89780,
	"./spei6_1_1976.png": 17300,
	"./spei6_1_1977.png": 28341,
	"./spei6_1_1978.png": 47608,
	"./spei6_1_1979.png": 4380,
	"./spei6_1_1980.png": 24712,
	"./spei6_1_1981.png": 76260,
	"./spei6_1_1982.png": 59956,
	"./spei6_1_1983.png": 45296,
	"./spei6_1_1984.png": 22776,
	"./spei6_1_1985.png": 19432,
	"./spei6_1_1986.png": 38496,
	"./spei6_1_1987.png": 41728,
	"./spei6_1_1988.png": 71396,
	"./spei6_1_1989.png": 45784,
	"./spei6_1_1990.png": 62804,
	"./spei6_1_1991.png": 94980,
	"./spei6_1_1992.png": 36672,
	"./spei6_1_1993.png": 86456,
	"./spei6_1_1994.png": 51632,
	"./spei6_1_1995.png": 86772,
	"./spei6_1_1996.png": 89316,
	"./spei6_1_1997.png": 46088,
	"./spei6_1_1998.png": 36628,
	"./spei6_1_1999.png": 75904,
	"./spei6_1_2000.png": 72908,
	"./spei6_1_2001.png": 46140,
	"./spei6_1_2002.png": 35820,
	"./spei6_1_2003.png": 82536,
	"./spei6_1_2004.png": 24340,
	"./spei6_1_2005.png": 43660,
	"./spei6_1_2006.png": 10804,
	"./spei6_1_2007.png": 75080,
	"./spei6_1_2008.png": 37100,
	"./spei6_1_2009.png": 80548,
	"./spei6_1_2010.png": 97772,
	"./spei6_1_2011.png": 40796,
	"./spei6_1_2012.png": 65252,
	"./spei6_1_2013.png": 14028,
	"./spei6_1_2014.png": 93800,
	"./spei6_1_2015.png": 92948,
	"./spei6_1_2016.png": 88764,
	"./spei6_1_2017.png": 25452,
	"./spei6_1_2018.png": 77780,
	"./spei6_1_2019.png": 73952,
	"./spei6_1_2020.png": 12567,
	"./spei6_1_2021.png": 85616,
	"./spei6_1_2022.png": 7764,
	"./spei6_1_2023.png": 17568,
	"./spei6_2_1950.png": 34076,
	"./spei6_2_1951.png": 26056,
	"./spei6_2_1952.png": 10048,
	"./spei6_2_1953.png": 14136,
	"./spei6_2_1954.png": 83324,
	"./spei6_2_1955.png": 40124,
	"./spei6_2_1956.png": 34772,
	"./spei6_2_1957.png": 99972,
	"./spei6_2_1958.png": 43480,
	"./spei6_2_1959.png": 64252,
	"./spei6_2_1960.png": 42608,
	"./spei6_2_1961.png": 19716,
	"./spei6_2_1962.png": 52732,
	"./spei6_2_1963.png": 82244,
	"./spei6_2_1964.png": 9151,
	"./spei6_2_1965.png": 17580,
	"./spei6_2_1966.png": 8072,
	"./spei6_2_1967.png": 89788,
	"./spei6_2_1968.png": 58216,
	"./spei6_2_1969.png": 58556,
	"./spei6_2_1970.png": 83799,
	"./spei6_2_1971.png": 34996,
	"./spei6_2_1972.png": 56580,
	"./spei6_2_1973.png": 97408,
	"./spei6_2_1974.png": 19296,
	"./spei6_2_1975.png": 64720,
	"./spei6_2_1976.png": 28908,
	"./spei6_2_1977.png": 51160,
	"./spei6_2_1978.png": 98492,
	"./spei6_2_1979.png": 97658,
	"./spei6_2_1980.png": 78708,
	"./spei6_2_1981.png": 89432,
	"./spei6_2_1982.png": 2364,
	"./spei6_2_1983.png": 77448,
	"./spei6_2_1984.png": 34604,
	"./spei6_2_1985.png": 55696,
	"./spei6_2_1986.png": 5356,
	"./spei6_2_1987.png": 62024,
	"./spei6_2_1988.png": 73200,
	"./spei6_2_1989.png": 88688,
	"./spei6_2_1990.png": 9548,
	"./spei6_2_1991.png": 18752,
	"./spei6_2_1992.png": 70224,
	"./spei6_2_1993.png": 91684,
	"./spei6_2_1994.png": 53408,
	"./spei6_2_1995.png": 90676,
	"./spei6_2_1996.png": 28248,
	"./spei6_2_1997.png": 22148,
	"./spei6_2_1998.png": 40532,
	"./spei6_2_1999.png": 23976,
	"./spei6_2_2000.png": 3800,
	"./spei6_2_2001.png": 31168,
	"./spei6_2_2002.png": 47856,
	"./spei6_2_2003.png": 93964,
	"./spei6_2_2004.png": 63432,
	"./spei6_2_2005.png": 93920,
	"./spei6_2_2006.png": 97852,
	"./spei6_2_2007.png": 92656,
	"./spei6_2_2008.png": 2548,
	"./spei6_2_2009.png": 46824,
	"./spei6_2_2010.png": 7644,
	"./spei6_2_2011.png": 11952,
	"./spei6_2_2012.png": 56524,
	"./spei6_2_2013.png": 20220,
	"./spei6_2_2014.png": 61431,
	"./spei6_2_2015.png": 83536,
	"./spei6_2_2016.png": 78636,
	"./spei6_2_2017.png": 57024,
	"./spei6_2_2018.png": 54980,
	"./spei6_2_2019.png": 84856,
	"./spei6_2_2020.png": 5716,
	"./spei6_2_2021.png": 59980,
	"./spei6_2_2022.png": 68364,
	"./spei6_2_2023.png": 57180,
	"./spei6_3_1950.png": 72996,
	"./spei6_3_1951.png": 26436,
	"./spei6_3_1952.png": 57016,
	"./spei6_3_1953.png": 28223,
	"./spei6_3_1954.png": 81728,
	"./spei6_3_1955.png": 17460,
	"./spei6_3_1956.png": 21332,
	"./spei6_3_1957.png": 68500,
	"./spei6_3_1958.png": 48956,
	"./spei6_3_1959.png": 67980,
	"./spei6_3_1960.png": 41192,
	"./spei6_3_1961.png": 38500,
	"./spei6_3_1962.png": 90756,
	"./spei6_3_1963.png": 46936,
	"./spei6_3_1964.png": 14352,
	"./spei6_3_1965.png": 80655,
	"./spei6_3_1966.png": 63684,
	"./spei6_3_1967.png": 82048,
	"./spei6_3_1968.png": 87360,
	"./spei6_3_1969.png": 48808,
	"./spei6_3_1970.png": 64616,
	"./spei6_3_1971.png": 62492,
	"./spei6_3_1972.png": 2292,
	"./spei6_3_1973.png": 10540,
	"./spei6_3_1974.png": 72456,
	"./spei6_3_1975.png": 69832,
	"./spei6_3_1976.png": 25316,
	"./spei6_3_1977.png": 70785,
	"./spei6_3_1978.png": 75360,
	"./spei6_3_1979.png": 82172,
	"./spei6_3_1980.png": 48412,
	"./spei6_3_1981.png": 75407,
	"./spei6_3_1982.png": 6688,
	"./spei6_3_1983.png": 90516,
	"./spei6_3_1984.png": 58500,
	"./spei6_3_1985.png": 83524,
	"./spei6_3_1986.png": 51696,
	"./spei6_3_1987.png": 49576,
	"./spei6_3_1988.png": 10084,
	"./spei6_3_1989.png": 66264,
	"./spei6_3_1990.png": 72307,
	"./spei6_3_1991.png": 23880,
	"./spei6_3_1992.png": 76248,
	"./spei6_3_1993.png": 20792,
	"./spei6_3_1994.png": 61216,
	"./spei6_3_1995.png": 62764,
	"./spei6_3_1996.png": 35408,
	"./spei6_3_1997.png": 61316,
	"./spei6_3_1998.png": 83944,
	"./spei6_3_1999.png": 81820,
	"./spei6_3_2000.png": 66500,
	"./spei6_3_2001.png": 90788,
	"./spei6_3_2002.png": 62364,
	"./spei6_3_2003.png": 82080,
	"./spei6_3_2004.png": 82848,
	"./spei6_3_2005.png": 98628,
	"./spei6_3_2006.png": 45644,
	"./spei6_3_2007.png": 40872,
	"./spei6_3_2008.png": 46284,
	"./spei6_3_2009.png": 26980,
	"./spei6_3_2010.png": 61387,
	"./spei6_3_2011.png": 4540,
	"./spei6_3_2012.png": 20528,
	"./spei6_3_2013.png": 58732,
	"./spei6_3_2014.png": 6572,
	"./spei6_3_2015.png": 77156,
	"./spei6_3_2016.png": 48872,
	"./spei6_3_2017.png": 90784,
	"./spei6_3_2018.png": 87268,
	"./spei6_3_2019.png": 16684,
	"./spei6_3_2020.png": 65856,
	"./spei6_3_2021.png": 56164,
	"./spei6_3_2022.png": 12132,
	"./spei6_3_2023.png": 36852,
	"./spei6_4_1950.png": 24608,
	"./spei6_4_1951.png": 83732,
	"./spei6_4_1952.png": 42444,
	"./spei6_4_1953.png": 97796,
	"./spei6_4_1954.png": 92140,
	"./spei6_4_1955.png": 36928,
	"./spei6_4_1956.png": 59388,
	"./spei6_4_1957.png": 11383,
	"./spei6_4_1958.png": 37128,
	"./spei6_4_1959.png": 38800,
	"./spei6_4_1960.png": 5796,
	"./spei6_4_1961.png": 57528,
	"./spei6_4_1962.png": 55764,
	"./spei6_4_1963.png": 54596,
	"./spei6_4_1964.png": 4900,
	"./spei6_4_1965.png": 56468,
	"./spei6_4_1966.png": 20572,
	"./spei6_4_1967.png": 19132,
	"./spei6_4_1968.png": 90652,
	"./spei6_4_1969.png": 22704,
	"./spei6_4_1970.png": 30023,
	"./spei6_4_1971.png": 41877,
	"./spei6_4_1972.png": 22116,
	"./spei6_4_1973.png": 57556,
	"./spei6_4_1974.png": 8392,
	"./spei6_4_1975.png": 6268,
	"./spei6_4_1976.png": 64468,
	"./spei6_4_1977.png": 32524,
	"./spei6_4_1978.png": 89292,
	"./spei6_4_1979.png": 78623,
	"./spei6_4_1980.png": 12840,
	"./spei6_4_1981.png": 88972,
	"./spei6_4_1982.png": 33724,
	"./spei6_4_1983.png": 9456,
	"./spei6_4_1984.png": 65964,
	"./spei6_4_1985.png": 93261,
	"./spei6_4_1986.png": 37324,
	"./spei6_4_1987.png": 24416,
	"./spei6_4_1988.png": 36120,
	"./spei6_4_1989.png": 51560,
	"./spei6_4_1990.png": 34031,
	"./spei6_4_1991.png": 65976,
	"./spei6_4_1992.png": 17144,
	"./spei6_4_1993.png": 50028,
	"./spei6_4_1994.png": 6036,
	"./spei6_4_1995.png": 38168,
	"./spei6_4_1996.png": 81876,
	"./spei6_4_1997.png": 24756,
	"./spei6_4_1998.png": 55815,
	"./spei6_4_1999.png": 86588,
	"./spei6_4_2000.png": 35584,
	"./spei6_4_2001.png": 36352,
	"./spei6_4_2002.png": 68484,
	"./spei6_4_2003.png": 99724,
	"./spei6_4_2004.png": 32692,
	"./spei6_4_2005.png": 15032,
	"./spei6_4_2006.png": 3036,
	"./spei6_4_2007.png": 37968,
	"./spei6_4_2008.png": 7732,
	"./spei6_4_2009.png": 91016,
	"./spei6_4_2010.png": 35244,
	"./spei6_4_2011.png": 89372,
	"./spei6_4_2012.png": 83820,
	"./spei6_4_2013.png": 87968,
	"./spei6_4_2014.png": 13480,
	"./spei6_4_2015.png": 33488,
	"./spei6_4_2016.png": 6196,
	"./spei6_4_2017.png": 3440,
	"./spei6_4_2018.png": 17165,
	"./spei6_4_2019.png": 89060,
	"./spei6_4_2020.png": 43956,
	"./spei6_4_2021.png": 32436,
	"./spei6_4_2022.png": 8748,
	"./spei6_4_2023.png": 3015,
	"./spei6_5_1950.png": 6224,
	"./spei6_5_1951.png": 91540,
	"./spei6_5_1952.png": 77160,
	"./spei6_5_1953.png": 63268,
	"./spei6_5_1954.png": 8048,
	"./spei6_5_1955.png": 51004,
	"./spei6_5_1956.png": 88416,
	"./spei6_5_1957.png": 56344,
	"./spei6_5_1958.png": 44196,
	"./spei6_5_1959.png": 37392,
	"./spei6_5_1960.png": 95328,
	"./spei6_5_1961.png": 35511,
	"./spei6_5_1962.png": 19780,
	"./spei6_5_1963.png": 9876,
	"./spei6_5_1964.png": 4364,
	"./spei6_5_1965.png": 41740,
	"./spei6_5_1966.png": 20861,
	"./spei6_5_1967.png": 82216,
	"./spei6_5_1968.png": 41332,
	"./spei6_5_1969.png": 21184,
	"./spei6_5_1970.png": 6748,
	"./spei6_5_1971.png": 22736,
	"./spei6_5_1972.png": 3468,
	"./spei6_5_1973.png": 85080,
	"./spei6_5_1974.png": 70824,
	"./spei6_5_1975.png": 62856,
	"./spei6_5_1976.png": 78184,
	"./spei6_5_1977.png": 11735,
	"./spei6_5_1978.png": 8088,
	"./spei6_5_1979.png": 21560,
	"./spei6_5_1980.png": 61620,
	"./spei6_5_1981.png": 19884,
	"./spei6_5_1982.png": 42060,
	"./spei6_5_1983.png": 36380,
	"./spei6_5_1984.png": 4340,
	"./spei6_5_1985.png": 41076,
	"./spei6_5_1986.png": 61932,
	"./spei6_5_1987.png": 39228,
	"./spei6_5_1988.png": 56672,
	"./spei6_5_1989.png": 60248,
	"./spei6_5_1990.png": 80604,
	"./spei6_5_1991.png": 11668,
	"./spei6_5_1992.png": 96100,
	"./spei6_5_1993.png": 90840,
	"./spei6_5_1994.png": 88660,
	"./spei6_5_1995.png": 29416,
	"./spei6_5_1996.png": 63172,
	"./spei6_5_1997.png": 65948,
	"./spei6_5_1998.png": 25832,
	"./spei6_5_1999.png": 91748,
	"./spei6_5_2000.png": 55792,
	"./spei6_5_2001.png": 47188,
	"./spei6_5_2002.png": 78868,
	"./spei6_5_2003.png": 12420,
	"./spei6_5_2004.png": 52924,
	"./spei6_5_2005.png": 84688,
	"./spei6_5_2006.png": 43039,
	"./spei6_5_2007.png": 63384,
	"./spei6_5_2008.png": 41316,
	"./spei6_5_2009.png": 69744,
	"./spei6_5_2010.png": 54828,
	"./spei6_5_2011.png": 79565,
	"./spei6_5_2012.png": 52028,
	"./spei6_5_2013.png": 63900,
	"./spei6_5_2014.png": 18624,
	"./spei6_5_2015.png": 86552,
	"./spei6_5_2016.png": 74404,
	"./spei6_5_2017.png": 16917,
	"./spei6_5_2018.png": 43912,
	"./spei6_5_2019.png": 80648,
	"./spei6_5_2020.png": 50612,
	"./spei6_5_2021.png": 45416,
	"./spei6_5_2022.png": 87372,
	"./spei6_5_2023.png": 38376,
	"./spei6_6_1950.png": 26360,
	"./spei6_6_1951.png": 48472,
	"./spei6_6_1952.png": 28760,
	"./spei6_6_1953.png": 17252,
	"./spei6_6_1954.png": 45504,
	"./spei6_6_1955.png": 20164,
	"./spei6_6_1956.png": 76116,
	"./spei6_6_1957.png": 71272,
	"./spei6_6_1958.png": 2320,
	"./spei6_6_1959.png": 75984,
	"./spei6_6_1960.png": 86452,
	"./spei6_6_1961.png": 98632,
	"./spei6_6_1962.png": 25012,
	"./spei6_6_1963.png": 13972,
	"./spei6_6_1964.png": 68816,
	"./spei6_6_1965.png": 62784,
	"./spei6_6_1966.png": 95292,
	"./spei6_6_1967.png": 38508,
	"./spei6_6_1968.png": 70252,
	"./spei6_6_1969.png": 14016,
	"./spei6_6_1970.png": 40780,
	"./spei6_6_1971.png": 49392,
	"./spei6_6_1972.png": 48812,
	"./spei6_6_1973.png": 13109,
	"./spei6_6_1974.png": 38736,
	"./spei6_6_1975.png": 93836,
	"./spei6_6_1976.png": 43812,
	"./spei6_6_1977.png": 37964,
	"./spei6_6_1978.png": 38808,
	"./spei6_6_1979.png": 72180,
	"./spei6_6_1980.png": 67199,
	"./spei6_6_1981.png": 33344,
	"./spei6_6_1982.png": 44588,
	"./spei6_6_1983.png": 83680,
	"./spei6_6_1984.png": 90484,
	"./spei6_6_1985.png": 12588,
	"./spei6_6_1986.png": 40988,
	"./spei6_6_1987.png": 33072,
	"./spei6_6_1988.png": 5780,
	"./spei6_6_1989.png": 17960,
	"./spei6_6_1990.png": 58136,
	"./spei6_6_1991.png": 91508,
	"./spei6_6_1992.png": 15583,
	"./spei6_6_1993.png": 79348,
	"./spei6_6_1994.png": 79196,
	"./spei6_6_1995.png": 23472,
	"./spei6_6_1996.png": 32527,
	"./spei6_6_1997.png": 29168,
	"./spei6_6_1998.png": 37728,
	"./spei6_6_1999.png": 67812,
	"./spei6_6_2000.png": 90636,
	"./spei6_6_2001.png": 94629,
	"./spei6_6_2002.png": 86136,
	"./spei6_6_2003.png": 27816,
	"./spei6_6_2004.png": 40684,
	"./spei6_6_2005.png": 55072,
	"./spei6_6_2006.png": 31696,
	"./spei6_6_2007.png": 19560,
	"./spei6_6_2008.png": 51240,
	"./spei6_6_2009.png": 9920,
	"./spei6_6_2010.png": 12072,
	"./spei6_6_2011.png": 92032,
	"./spei6_6_2012.png": 7992,
	"./spei6_6_2013.png": 16384,
	"./spei6_6_2014.png": 31063,
	"./spei6_6_2015.png": 97460,
	"./spei6_6_2016.png": 63324,
	"./spei6_6_2017.png": 2855,
	"./spei6_6_2018.png": 62352,
	"./spei6_6_2019.png": 79180,
	"./spei6_6_2020.png": 88176,
	"./spei6_6_2021.png": 61656,
	"./spei6_6_2022.png": 92284,
	"./spei6_6_2023.png": 56620,
	"./spei6_7_1950.png": 47548,
	"./spei6_7_1951.png": 57548,
	"./spei6_7_1952.png": 37972,
	"./spei6_7_1953.png": 69696,
	"./spei6_7_1954.png": 31044,
	"./spei6_7_1955.png": 51676,
	"./spei6_7_1956.png": 15084,
	"./spei6_7_1957.png": 82480,
	"./spei6_7_1958.png": 22983,
	"./spei6_7_1959.png": 29424,
	"./spei6_7_1960.png": 87200,
	"./spei6_7_1961.png": 77652,
	"./spei6_7_1962.png": 97856,
	"./spei6_7_1963.png": 24988,
	"./spei6_7_1964.png": 77416,
	"./spei6_7_1965.png": 54368,
	"./spei6_7_1966.png": 72656,
	"./spei6_7_1967.png": 98136,
	"./spei6_7_1968.png": 34628,
	"./spei6_7_1969.png": 268,
	"./spei6_7_1970.png": 35908,
	"./spei6_7_1971.png": 91436,
	"./spei6_7_1972.png": 68072,
	"./spei6_7_1973.png": 21944,
	"./spei6_7_1974.png": 68498,
	"./spei6_7_1975.png": 70304,
	"./spei6_7_1976.png": 93472,
	"./spei6_7_1977.png": 61180,
	"./spei6_7_1978.png": 27288,
	"./spei6_7_1979.png": 71772,
	"./spei6_7_1980.png": 36656,
	"./spei6_7_1981.png": 7816,
	"./spei6_7_1982.png": 26000,
	"./spei6_7_1983.png": 76932,
	"./spei6_7_1984.png": 42412,
	"./spei6_7_1985.png": 57960,
	"./spei6_7_1986.png": 60300,
	"./spei6_7_1987.png": 53647,
	"./spei6_7_1988.png": 85723,
	"./spei6_7_1989.png": 12600,
	"./spei6_7_1990.png": 49640,
	"./spei6_7_1991.png": 57792,
	"./spei6_7_1992.png": 10775,
	"./spei6_7_1993.png": 78644,
	"./spei6_7_1994.png": 44036,
	"./spei6_7_1995.png": 58159,
	"./spei6_7_1996.png": 86584,
	"./spei6_7_1997.png": 6148,
	"./spei6_7_1998.png": 28064,
	"./spei6_7_1999.png": 72612,
	"./spei6_7_2000.png": 20956,
	"./spei6_7_2001.png": 77812,
	"./spei6_7_2002.png": 91564,
	"./spei6_7_2003.png": 42656,
	"./spei6_7_2004.png": 65576,
	"./spei6_7_2005.png": 17123,
	"./spei6_7_2006.png": 72616,
	"./spei6_7_2007.png": 92192,
	"./spei6_7_2008.png": 71640,
	"./spei6_7_2009.png": 60296,
	"./spei6_7_2010.png": 40468,
	"./spei6_7_2011.png": 64568,
	"./spei6_7_2012.png": 61184,
	"./spei6_7_2013.png": 10968,
	"./spei6_7_2014.png": 40707,
	"./spei6_7_2015.png": 11804,
	"./spei6_7_2016.png": 64420,
	"./spei6_7_2017.png": 16500,
	"./spei6_7_2018.png": 17680,
	"./spei6_7_2019.png": 66540,
	"./spei6_7_2020.png": 89128,
	"./spei6_7_2021.png": 61064,
	"./spei6_7_2022.png": 77208,
	"./spei6_7_2023.png": 46396,
	"./spei6_8_1950.png": 87016,
	"./spei6_8_1951.png": 80176,
	"./spei6_8_1952.png": 28172,
	"./spei6_8_1953.png": 35428,
	"./spei6_8_1954.png": 55896,
	"./spei6_8_1955.png": 83644,
	"./spei6_8_1956.png": 47140,
	"./spei6_8_1957.png": 86240,
	"./spei6_8_1958.png": 64324,
	"./spei6_8_1959.png": 44759,
	"./spei6_8_1960.png": 3144,
	"./spei6_8_1961.png": 67436,
	"./spei6_8_1962.png": 98891,
	"./spei6_8_1963.png": 83932,
	"./spei6_8_1964.png": 99892,
	"./spei6_8_1965.png": 89044,
	"./spei6_8_1966.png": 64588,
	"./spei6_8_1967.png": 16400,
	"./spei6_8_1968.png": 3808,
	"./spei6_8_1969.png": 24152,
	"./spei6_8_1970.png": 12380,
	"./spei6_8_1971.png": 36840,
	"./spei6_8_1972.png": 56228,
	"./spei6_8_1973.png": 16012,
	"./spei6_8_1974.png": 36212,
	"./spei6_8_1975.png": 93320,
	"./spei6_8_1976.png": 83484,
	"./spei6_8_1977.png": 10708,
	"./spei6_8_1978.png": 95348,
	"./spei6_8_1979.png": 17336,
	"./spei6_8_1980.png": 42880,
	"./spei6_8_1981.png": 5444,
	"./spei6_8_1982.png": 10128,
	"./spei6_8_1983.png": 87048,
	"./spei6_8_1984.png": 67692,
	"./spei6_8_1985.png": 61299,
	"./spei6_8_1986.png": 3992,
	"./spei6_8_1987.png": 29768,
	"./spei6_8_1988.png": 66503,
	"./spei6_8_1989.png": 68736,
	"./spei6_8_1990.png": 31920,
	"./spei6_8_1991.png": 70288,
	"./spei6_8_1992.png": 8488,
	"./spei6_8_1993.png": 70948,
	"./spei6_8_1994.png": 41392,
	"./spei6_8_1995.png": 10824,
	"./spei6_8_1996.png": 71660,
	"./spei6_8_1997.png": 98436,
	"./spei6_8_1998.png": 55640,
	"./spei6_8_1999.png": 85880,
	"./spei6_8_2000.png": 95784,
	"./spei6_8_2001.png": 45600,
	"./spei6_8_2002.png": 70176,
	"./spei6_8_2003.png": 66096,
	"./spei6_8_2004.png": 87112,
	"./spei6_8_2005.png": 18792,
	"./spei6_8_2006.png": 58372,
	"./spei6_8_2007.png": 9040,
	"./spei6_8_2008.png": 42124,
	"./spei6_8_2009.png": 34724,
	"./spei6_8_2010.png": 85400,
	"./spei6_8_2011.png": 54588,
	"./spei6_8_2012.png": 56784,
	"./spei6_8_2013.png": 80928,
	"./spei6_8_2014.png": 71236,
	"./spei6_8_2015.png": 37124,
	"./spei6_8_2016.png": 56423,
	"./spei6_8_2017.png": 46752,
	"./spei6_8_2018.png": 40636,
	"./spei6_8_2019.png": 39688,
	"./spei6_8_2020.png": 47508,
	"./spei6_8_2021.png": 56476,
	"./spei6_8_2022.png": 66700,
	"./spei6_8_2023.png": 45820,
	"./spei6_9_1950.png": 56360,
	"./spei6_9_1951.png": 39056,
	"./spei6_9_1952.png": 5856,
	"./spei6_9_1953.png": 43368,
	"./spei6_9_1954.png": 64196,
	"./spei6_9_1955.png": 17996,
	"./spei6_9_1956.png": 22064,
	"./spei6_9_1957.png": 15604,
	"./spei6_9_1958.png": 95340,
	"./spei6_9_1959.png": 34432,
	"./spei6_9_1960.png": 86688,
	"./spei6_9_1961.png": 824,
	"./spei6_9_1962.png": 66204,
	"./spei6_9_1963.png": 94628,
	"./spei6_9_1964.png": 91812,
	"./spei6_9_1965.png": 59984,
	"./spei6_9_1966.png": 59964,
	"./spei6_9_1967.png": 94780,
	"./spei6_9_1968.png": 50344,
	"./spei6_9_1969.png": 46196,
	"./spei6_9_1970.png": 4892,
	"./spei6_9_1971.png": 23584,
	"./spei6_9_1972.png": 61460,
	"./spei6_9_1973.png": 5968,
	"./spei6_9_1974.png": 20644,
	"./spei6_9_1975.png": 50976,
	"./spei6_9_1976.png": 31264,
	"./spei6_9_1977.png": 73292,
	"./spei6_9_1978.png": 77552,
	"./spei6_9_1979.png": 87776,
	"./spei6_9_1980.png": 32424,
	"./spei6_9_1981.png": 87464,
	"./spei6_9_1982.png": 84524,
	"./spei6_9_1983.png": 172,
	"./spei6_9_1984.png": 19612,
	"./spei6_9_1985.png": 79208,
	"./spei6_9_1986.png": 95840,
	"./spei6_9_1987.png": 9556,
	"./spei6_9_1988.png": 556,
	"./spei6_9_1989.png": 79776,
	"./spei6_9_1990.png": 75591,
	"./spei6_9_1991.png": 67220,
	"./spei6_9_1992.png": 40495,
	"./spei6_9_1993.png": 15980,
	"./spei6_9_1994.png": 25248,
	"./spei6_9_1995.png": 78452,
	"./spei6_9_1996.png": 91088,
	"./spei6_9_1997.png": 87023,
	"./spei6_9_1998.png": 50008,
	"./spei6_9_1999.png": 52828,
	"./spei6_9_2000.png": 74675,
	"./spei6_9_2001.png": 67092,
	"./spei6_9_2002.png": 25280,
	"./spei6_9_2003.png": 86716,
	"./spei6_9_2004.png": 78228,
	"./spei6_9_2005.png": 49832,
	"./spei6_9_2006.png": 94536,
	"./spei6_9_2007.png": 66948,
	"./spei6_9_2008.png": 50420,
	"./spei6_9_2009.png": 22160,
	"./spei6_9_2010.png": 8220,
	"./spei6_9_2011.png": 6808,
	"./spei6_9_2012.png": 11160,
	"./spei6_9_2013.png": 75204,
	"./spei6_9_2014.png": 108,
	"./spei6_9_2015.png": 37928,
	"./spei6_9_2016.png": 6456,
	"./spei6_9_2017.png": 13565,
	"./spei6_9_2018.png": 65972,
	"./spei6_9_2019.png": 10112,
	"./spei6_9_2020.png": 80424,
	"./spei6_9_2021.png": 78300,
	"./spei6_9_2022.png": 58881,
	"./spei6_9_2023.png": 82176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93544;